window.ELEVENINE_PRODUCT_HANDLES = Object.freeze({"1":"acelerador-de-repuesto-enine","2":"baby-bike","3":"baby-bike-edicion-moto","4":"bandana-off-road","5":"bateria-extra","6":"bicicleta-de-montana-mtb-29-deegan","7":"bicicleta-electrica-enine-rodado-12","8":"bicicleta-electrica-enine-rodado-16","9":"bicicleta-electrica-enine-rodado-20","10":"cargador-de-bateria-para-enine","11":"carpas-toldos-personalizados","12":"casco-adulto-mtb","13":"casco-dropframe-mtb","14":"casco-fullface-infantil","15":"casco-fullface-mtb-adulto","16":"casco-mtb-match","17":"control-de-velocidad-y-apagado-enine","18":"controlador-para-enine-12-o-16","19":"goggles-delta-force","20":"goggles-force-one","21":"guantes-eln9","22":"hyper-bee","23":"kit-de-graficos-para-enine","24":"mica-repuesto-goggles-force-one","25":"mt20-bicicleta-infantil","26":"sombrero-racing-de-paja","27":"stark-varg-ex","28":"stark-varg-mx1-2","29":"stark-varg-sm","30":"strider-balance-edicion-moto","31":"strider-bicicleta-de-balance","32":"sur-ron-light-bee-x","33":"sur-ron-ultra-bee","34":"sur-ron-light-bee-2","35":"surron-rear-shock-upgrade-spring","36":"surron-foot-pegs-ultra-bee","37":"surron-front-disc-guard-ultra-bee","38":"surron-adjustable-brake-lever-set-ultra-bee","39":"surron-reinforced-shock-triangle-bracket","40":"surron-shock-linkage-bracket","41":"surron-caliper-bracket-a-type","42":"surron-front-fork-anchor","43":"surron-handlebar-riser","44":"surron-front-floating-brake-rotor","45":"surron-rotor-adapter-set-front-rear","46":"surron-folding-brake-lever-light-bee-talaria","47":"surron-rear-sprocket-light-bee","48":"surron-skid-plate-light-bee","49":"surron-extended-rear-fender-light-bee","50":"surron-foot-pegs-light-bee","51":"surron-front-disc-guard-light-bee","52":"surron-brake-pads","53":"surron-seat-riser","54":"surron-adjustable-kickstand"});
window.ELEVENINE_PRODUCT_URL = id => {
  const handle = window.ELEVENINE_PRODUCT_HANDLES[String(id)];
  if (!handle) return '/#productos';
  const catalog = window.ELEVENINE_NATIVE_CATALOG || {};
  const nativeProduct = catalog[handle];
  if (nativeProduct && nativeProduct.url) return nativeProduct.url;
  return Object.keys(catalog).length ? '/#productos' : '/products/' + encodeURIComponent(handle);
};

/* assets/js/product-videos.js */
(() => {
  'use strict';

  const productMedia = {
    4: {
      images: {
        Color: {
          Morado: window.ELEVENINE_THEME_ASSET("asset:589f6967d741"),
          Negro: window.ELEVENINE_THEME_ASSET("asset:4a93c8c7ef71"),
          Azul: window.ELEVENINE_THEME_ASSET("asset:8d673d93b788"),
          Rosa: window.ELEVENINE_THEME_ASSET("asset:e7610608f253")
        }
      }
    },
    2: {
      default: window.ELEVENINE_THEME_ASSET("asset:655f5e3874ae"),
      variants: {
        Color: {
          Amarillo: window.ELEVENINE_THEME_ASSET("asset:655f5e3874ae"),
          Rosa: window.ELEVENINE_THEME_ASSET("asset:aaac4be65147")
        }
      }
    },
    3: {
      default: window.ELEVENINE_THEME_ASSET("asset:1eb909aba670"),
      variants: {
        'Edición': {
          BMW: window.ELEVENINE_THEME_ASSET("asset:1eb909aba670"),
          HONDA: window.ELEVENINE_THEME_ASSET("asset:8e9ddd646f3f"),
          KTM: window.ELEVENINE_THEME_ASSET("asset:5dabefafefaf"),
          Rockstar: window.ELEVENINE_THEME_ASSET("asset:37833cc0679a"),
          SHERCO: window.ELEVENINE_THEME_ASSET("asset:1ee18b7b219e"),
          YAMAHA: window.ELEVENINE_THEME_ASSET("asset:0d4d8291f7b6")
        }
      }
    },
    6: {
      default: window.ELEVENINE_THEME_ASSET("asset:3c9f215f9017"),
      variants: {
        Color: {
          Gris: window.ELEVENINE_THEME_ASSET("asset:3c9f215f9017"),
          Azul: window.ELEVENINE_THEME_ASSET("asset:c38d16307abb")
        }
      }
    },
    7: { default: window.ELEVENINE_THEME_ASSET("asset:7837e5e56cb3") },
    8: { default: window.ELEVENINE_THEME_ASSET("asset:9b22edac4261") },
    9: { default: window.ELEVENINE_THEME_ASSET("asset:305777185746") },
    11: {
      default: window.ELEVENINE_THEME_ASSET("asset:75afbdef651d"),
      galleryVideos: [
        {
          src: window.ELEVENINE_THEME_ASSET("asset:04fa91950eb6"),
          label: 'Conjunto de carpas KTM · vista de pista'
        }
      ]
    },
    12: {
      default: window.ELEVENINE_THEME_ASSET("asset:6d79b9988a7c"),
      variants: {
        Color: {
          'Blanco/Rojo': window.ELEVENINE_THEME_ASSET("asset:6d79b9988a7c")
        }
      }
    },
    13: {
      default: window.ELEVENINE_THEME_ASSET("asset:2312b312a803"),
      variants: {
        Color: {
          Gris: window.ELEVENINE_THEME_ASSET("asset:2312b312a803"),
          Negro: window.ELEVENINE_THEME_ASSET("asset:dac5d269ac7a"),
          Rojo: window.ELEVENINE_THEME_ASSET("asset:fc9f3f70e26f")
        }
      }
    },
    15: {
      default: window.ELEVENINE_THEME_ASSET("asset:9bdb9867f9e8"),
      variants: {
        Color: {
          Negro: window.ELEVENINE_THEME_ASSET("asset:9bdb9867f9e8"),
          'Blanco/Rojo': window.ELEVENINE_THEME_ASSET("asset:4b33453229cc"),
          'Blanco/Naranja': window.ELEVENINE_THEME_ASSET("asset:4b33453229cc")
        }
      }
    },
    16: {
      default: window.ELEVENINE_THEME_ASSET("asset:68cb120cb004"),
      variants: {
        Color: {
          Blanco: window.ELEVENINE_THEME_ASSET("asset:68cb120cb004"),
          'Negro Brillante': window.ELEVENINE_THEME_ASSET("asset:5d66b2af1cdc"),
          Negro: window.ELEVENINE_THEME_ASSET("asset:f61e3a53c0c9"),
          Azul: window.ELEVENINE_THEME_ASSET("asset:4bc2a891e2f8")
        }
      }
    },
    19: {
      default: window.ELEVENINE_THEME_ASSET("asset:7294d1e1e794"),
      variants: {
        'Versión': {
          Negro: window.ELEVENINE_THEME_ASSET("asset:7294d1e1e794"),
          'NEGRO PERSONALIZADO': window.ELEVENINE_THEME_ASSET("asset:5c55746af400")
        }
      }
    },
    20: {
      default: window.ELEVENINE_THEME_ASSET("asset:085baf34d756"),
      variants: {
        'Versión': {
          Blanco: window.ELEVENINE_THEME_ASSET("asset:085baf34d756"),
          Negro: window.ELEVENINE_THEME_ASSET("asset:bbf64839b69b"),
          Rojo: window.ELEVENINE_THEME_ASSET("asset:ca3bd0578be3"),
          'BLANCO PERSONALIZADO': window.ELEVENINE_THEME_ASSET("asset:232ad3673f52"),
          'NEGRO PERSONALIZADO': window.ELEVENINE_THEME_ASSET("asset:1d4f486d58ee"),
          'ROJO PERSONALIZADO': window.ELEVENINE_THEME_ASSET("asset:ab8f4ff8330a")
        }
      }
    },
    21: { default: window.ELEVENINE_THEME_ASSET("asset:4647a8443cad") },
    22: {
      default: window.ELEVENINE_THEME_ASSET("asset:ed496aef5577"),
      variants: {
        Color: {
          Amarillo: window.ELEVENINE_THEME_ASSET("asset:ef198b768a7b"),
          Verde: window.ELEVENINE_THEME_ASSET("asset:a72562c08884"),
          Azul: window.ELEVENINE_THEME_ASSET("asset:ed496aef5577"),
          Rosa: window.ELEVENINE_THEME_ASSET("asset:c3543e034bb4")
        }
      },
      modelVariants: {
        '2025': {
          Color: {
            Amarillo: window.ELEVENINE_THEME_ASSET("asset:ef198b768a7b"),
            Verde: window.ELEVENINE_THEME_ASSET("asset:a72562c08884"),
            Azul: window.ELEVENINE_THEME_ASSET("asset:ed496aef5577"),
            Rosa: window.ELEVENINE_THEME_ASSET("asset:c3543e034bb4")
          }
        },
        '2026': {
          Color: {
            Verde: window.ELEVENINE_THEME_ASSET("asset:a72562c08884"),
            Azul: window.ELEVENINE_THEME_ASSET("asset:ed496aef5577"),
            Amarillo: window.ELEVENINE_THEME_ASSET("asset:ef198b768a7b")
          }
        }
      },
      modelDefaults: {
        '2025': window.ELEVENINE_THEME_ASSET("asset:c3543e034bb4"),
        '2026': window.ELEVENINE_THEME_ASSET("asset:ed496aef5577")
      }
    },
    24: {
      default: window.ELEVENINE_THEME_ASSET("asset:0cc134fa73b5"),
      variants: {
        Color: {
          Blanco: window.ELEVENINE_THEME_ASSET("asset:0cc134fa73b5"),
          Negro: window.ELEVENINE_THEME_ASSET("asset:37c6eb331a65"),
          Azul: window.ELEVENINE_THEME_ASSET("asset:de3e001ba06c")
        }
      }
    },
    25: { default: window.ELEVENINE_THEME_ASSET("asset:ea344e6a3972") },
    26: {
      default: window.ELEVENINE_THEME_ASSET("asset:facab8256e04"),
      variants: {
        'Diseño': {
          KTM: window.ELEVENINE_THEME_ASSET("asset:facab8256e04"),
          ELN9: window.ELEVENINE_THEME_ASSET("asset:af3dddd82b42"),
          TLD: window.ELEVENINE_THEME_ASSET("asset:4c81e72fc850")
        }
      }
    },
    27: {
      default: window.ELEVENINE_THEME_ASSET("asset:a371fd914084"),
      variants: {
        Color: {
          Blanco: window.ELEVENINE_THEME_ASSET("asset:a371fd914084"),
          Gris: window.ELEVENINE_THEME_ASSET("asset:ee909696c3b7"),
          Rojo: window.ELEVENINE_THEME_ASSET("asset:e9c81a131df7")
        }
      }
    },
    28: {
      default: window.ELEVENINE_THEME_ASSET("asset:8e3cedf5c088"),
      variants: {
        Color: {
          Blanco: window.ELEVENINE_THEME_ASSET("asset:f6becf0dfdf7"),
          Gris: window.ELEVENINE_THEME_ASSET("asset:8e3cedf5c088"),
          Rojo: window.ELEVENINE_THEME_ASSET("asset:669142a8ad92")
        }
      }
    },
    29: {
      default: window.ELEVENINE_THEME_ASSET("asset:90d1930a7a82"),
      variants: {
        Color: {
          Blanco: window.ELEVENINE_THEME_ASSET("asset:a0cbb7132ccf"),
          Gris: window.ELEVENINE_THEME_ASSET("asset:acd1e06ad53e"),
          Rojo: window.ELEVENINE_THEME_ASSET("asset:90d1930a7a82")
        }
      }
    },
    30: {
      default: window.ELEVENINE_THEME_ASSET("asset:23936fcb2ffe"),
      variants: {
        'Edición': {
          BMW: window.ELEVENINE_THEME_ASSET("asset:23936fcb2ffe"),
          HONDA: window.ELEVENINE_THEME_ASSET("asset:3cf3c88f7574"),
          KTM: window.ELEVENINE_THEME_ASSET("asset:e1f31f743f50"),
          Rockstar: window.ELEVENINE_THEME_ASSET("asset:4f3141da28b3"),
          SHERCO: window.ELEVENINE_THEME_ASSET("asset:f106089a09ba"),
          YAMAHA: window.ELEVENINE_THEME_ASSET("asset:31e9b61635ff")
        }
      }
    },
    31: {
      default: window.ELEVENINE_THEME_ASSET("asset:d6787f47ca72"),
      variants: {
        Color: {
          Azul: window.ELEVENINE_THEME_ASSET("asset:d6787f47ca72"),
          Negro: window.ELEVENINE_THEME_ASSET("asset:a1477a581a36"),
          Rojo: window.ELEVENINE_THEME_ASSET("asset:d3c2e38c0799"),
          Rosa: window.ELEVENINE_THEME_ASSET("asset:1e3fbe3a2b27")
        }
      }
    },
    32: {
      default: window.ELEVENINE_THEME_ASSET("asset:50dbc6e571c0"),
      variants: {
        Color: {
          Morado: window.ELEVENINE_THEME_ASSET("asset:8eeeae526130"),
          Verde: window.ELEVENINE_THEME_ASSET("asset:2672980aa77f"),
          Negro: window.ELEVENINE_THEME_ASSET("asset:50dbc6e571c0"),
          Azul: window.ELEVENINE_THEME_ASSET("asset:f663f0e22ad9"),
          Blanco: window.ELEVENINE_THEME_ASSET("asset:b61ab74c8cc4")
        }
      }
    },
    33: {
      default: window.ELEVENINE_THEME_ASSET("asset:e9b45b6dea7c"),
      variants: {
        Color: {
          'Café': window.ELEVENINE_THEME_ASSET("asset:e9b45b6dea7c"),
          Negro: window.ELEVENINE_THEME_ASSET("asset:5728cd662893")
        }
      }
    },
    34: {
      default: window.ELEVENINE_THEME_ASSET("asset:b30fb318fd9f"),
      variants: {
        Color: {
          Negro: window.ELEVENINE_THEME_ASSET("asset:f030b1edf835"),
          Verde: window.ELEVENINE_THEME_ASSET("asset:ddafb8c4467b"),
          Blanco: window.ELEVENINE_THEME_ASSET("asset:b30fb318fd9f"),
          'Café': window.ELEVENINE_THEME_ASSET("asset:63a87851009a")
        }
      }
    }
  };

  const videos = {
    1: window.ELEVENINE_THEME_ASSET("asset:b23621c08d17"),
    5: window.ELEVENINE_THEME_ASSET("asset:56930e3e5f06"),
    10: window.ELEVENINE_THEME_ASSET("asset:82767e516d2d"),
    14: window.ELEVENINE_THEME_ASSET("asset:a08629666d1c"),
    17: window.ELEVENINE_THEME_ASSET("asset:22966fe6c960"),
    18: window.ELEVENINE_THEME_ASSET("asset:019092e0fa59")
  };

  Object.entries(productMedia).forEach(([id, media]) => {
    videos[id] = media.default;
  });

  window.ELEVENINE_PRODUCT_MEDIA = productMedia;
  window.ELEVENINE_PRODUCT_VIDEOS = videos;

  if (Array.isArray(window.ELEVENINE_PRODUCTS)) {
    window.ELEVENINE_PRODUCTS.forEach(product => {
      const media = productMedia[product.id];
      if (videos[product.id]) product.video = videos[product.id];
      if (media?.variants) product.variantVideos = media.variants;
      if (media?.modelVariants) product.modelVariantVideos = media.modelVariants;
      if (media?.modelDefaults) product.modelDefaultVideos = media.modelDefaults;
      if (media?.images) product.variantImages = media.images;
      if (media?.galleryVideos) product.galleryVideos = media.galleryVideos;
    });
  }
})();




/* ================================================================
   ELEVENINE® — Frontend premium · Catálogo real (elevenine.com.mx)
   Datos extraídos del sitio actual. WGM · White Global Marketing
================================================================ */
'use strict';

/* ---------- Utilidades ---------- */
const U='https://elevenine.com.mx/wp-content/uploads/';
const img=(p,ext)=>/^(?:assets\/|https?:\/\/|\/\/)/.test(String(p))?p:U+p+'.'+(ext||'jpg');
const thumb=(p,ext)=>/^(?:assets\/|https?:\/\/|\/\/)/.test(String(p))?p:U+p+'-300x300.'+(ext||'jpg');
const money=n=>n==null?'PRECIO POR CONFIRMAR':'$'+n.toLocaleString('es-MX',{minimumFractionDigits:2});
const priceLabel=p=>p.price==null?'PRECIO POR CONFIRMAR':(Array.isArray(p.price)?'Desde '+money(Math.min(...p.price.map(Number).filter(Number.isFinite))):money(p.price));
const WA='523327052074';
const esc=s=>String(s).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
const ACTIVE_CATEGORY=window.ELEVENINE_COLLECTION_CATEGORY||new URLSearchParams(location.search).get('categoria');

const COLORHEX={
  'Amarillo':'#F2C230','Rosa':'#F06AA7','Morado':'#7A4FD0','Negro':'#191919','Azul':'#2159C3','Verde':'#3AA845',
  'Gris':'#8A8D90','Rojo':'#C8262C','Blanco':'#F5F5F2','Café':'#6B4A2F','Negro/Verde':'#1f3d24','Blanco/Rojo':'#e8dede',
  'Negro Brillante':'#0a0a0a','BMW':'#1C69D4','HONDA':'#CC0000','KTM':'#FF6600','Rockstar':'#FFD700','YAMAHA':'#0A3AA9','SHERCO':'#123B7A',
  'NEGRO PERSONALIZADO':'#191919','BLANCO PERSONALIZADO':'#F5F5F2','ROJO PERSONALIZADO':'#C8262C','ELN9':'#111111','TLD':'#D02030'
};

/* ---------- Catálogo real ---------- */
const P=[
{id:1,n:'Acelerador de repuesto ⚡eNINE',cat:'Accesorios',price:799,img:'2023/04/Bicicleta-Electrica-ENINE-Acelerador',stock:1,y:2023},
{id:2,n:'BABY BIKE',cat:'Bicicletas Infantiles',price:1190,img:'2022/10/babybike-2',stock:1,y:2022,vars:{Color:['Amarillo','Rosa']},age:'baby'},
{id:3,n:'BABY BIKE EDICIÓN MOTO',cat:'Bicicletas Infantiles',price:[1190,1200],img:window.ELEVENINE_THEME_ASSET("asset:14caf35e37ae"),stock:1,y:2022,vars:{'Edición':['BMW','HONDA','KTM','Rockstar','YAMAHA','SHERCO']},age:'baby'},
{id:4,n:'Bandana OFF ROAD',cat:'Accesorios',price:99,img:'2024/07/BD6',stock:1,y:2024,vars:{Color:['Morado','Negro','Azul','Rosa']},gear:1},
{id:5,n:'BATERÍA EXTRA',cat:'Accesorios',price:3500,img:window.ELEVENINE_THEME_ASSET("asset:85206b0a1105"),stock:1,y:2022},
{id:7,n:'Bicicleta Eléctrica ⚡eNINE Rodado 12″',cat:'Bicicletas Infantiles',price:16300,img:window.ELEVENINE_THEME_ASSET("asset:0cd72922418b"),stock:1,y:2022,age:'electric'},
{id:8,n:'Bicicleta Eléctrica ⚡eNINE Rodado 16″',cat:'Bicicletas Infantiles',price:17500,img:window.ELEVENINE_THEME_ASSET("asset:50cf1ab22a3e"),stock:0,y:2022,age:'electric'},
{id:9,n:'Bicicleta Eléctrica ⚡eNINE Rodado 20″',cat:'Bicicletas Infantiles',price:19000,img:window.ELEVENINE_THEME_ASSET("asset:2fecd7d0dd62"),stock:1,y:2024,age:'electric'},
{id:10,n:'Cargador de Batería para ⚡eNINE',cat:'Accesorios',price:799,img:'2023/03/Bicicleta-Electrica-ENINE-Cargador-1-',stock:1,y:2023},
{id:11,n:'Carpas Toldos Personalizados',cat:'Carpas Profesionales',price:[16000,47000],img:window.ELEVENINE_THEME_ASSET("asset:4c551889f173"),stock:1,y:2024,vars:{Medida:['3x3 NACIONAL','3x3 PREMIUM IMPORTADO','3x6 NACIONAL','3X6 PREMIUM IMPORTADO','4X8 PREMIUM IMPORTADO']}},
{id:12,n:'CASCO ADULTO MTB',cat:'Cascos Adultos MTB',price:990,img:'2022/10/casco-1',stock:1,y:2022,vars:{Color:['Negro/Verde','Blanco/Rojo']},gear:1},
{id:13,n:'Casco Dropframe MTB',cat:'Cascos Adultos MTB',price:1872,img:'2023/07/Casco-Dropframe-2',stock:1,y:2023,vars:{Color:['Gris','Negro','Rojo'],Talla:['S','M']},gear:1},
{id:14,n:'CASCO FULLFACE INFANTIL',cat:'Cascos Infantiles',price:1200,img:window.ELEVENINE_THEME_ASSET("asset:42a998c6e1e0"),stock:1,y:2022,gear:1},
{id:15,n:'CASCO FULLFACE MTB ADULTO',cat:'Cascos Adultos MTB',price:2540,img:window.ELEVENINE_THEME_ASSET("asset:0b852ea01ffe"),ext:'jpeg',stock:1,y:2023,vars:{Color:['Negro','Blanco/Rojo']},gear:1},
{id:16,n:'Casco MTB MATCH',cat:'Cascos Adultos MTB',price:1490,img:window.ELEVENINE_THEME_ASSET("asset:96b15923de4d"),stock:1,y:2024,vars:{Color:['Blanco','Negro Brillante','Negro','Azul']},gear:1},
{id:17,n:'Control de Velocidad y Apagado ⚡eNINE',cat:'Accesorios',price:799,img:'2023/04/Bicicleta-Electrica-ENINE-Control',stock:1,y:2023},
{id:18,n:'Controlador para ⚡eNINE 12″ o 16″',cat:'Accesorios',price:799,img:'2023/04/Bicicleta-Electrica-ENINE-Controlador',stock:1,y:2023},
{id:19,n:'Goggles DELTA FORCE',cat:'Goggles',price:[990,1150],img:'2024/02/DELTA-FORCE',stock:1,y:2024,vars:{'Versión':['Negro','NEGRO PERSONALIZADO']},gear:1},
{id:20,n:'Goggles FORCE ONE',cat:'Goggles',price:[990,1150],img:window.ELEVENINE_THEME_ASSET("asset:5e02558648f4"),stock:1,y:2025,vars:{'Versión':['Blanco','Negro','Rojo','BLANCO PERSONALIZADO','NEGRO PERSONALIZADO','ROJO PERSONALIZADO']},gear:1},
{id:21,n:'Guantes ELN9',cat:'Guantes',price:450,img:window.ELEVENINE_THEME_ASSET("asset:1e50ad996bbd"),stock:1,y:2025,vars:{Talla:['M','L']},gear:1},
{id:22,n:'HYPER BEE',cat:'SUR-RON',price:83000,img:window.ELEVENINE_THEME_ASSET("asset:3f2a466e0c6b"),stock:1,y:2026,vars:{Color:['Verde','Amarillo','Blanco','Azul']}},
{id:23,n:'Kit de Gráficos para ⚡eNINE',cat:'Accesorios',price:849,img:'2022/10/graficos-ENINE',ext:'jpeg',stock:1,y:2022},
{id:24,n:'Mica Repuesto Goggles FORCE ONE',cat:'Goggles',price:150,img:'2026/04/MICA-CLRA',stock:1,y:2026,vars:{Color:['Blanco','Negro','Azul']},gear:1},
{id:25,n:'MT20 Bicicleta Infantil',cat:'Bicicletas Infantiles',price:6300,img:'2025/01/MT20-2',stock:1,y:2025,age:'big'},
{id:26,n:'Sombrero Racing de Paja',cat:'Sombreros Racing',price:[500,750],img:window.ELEVENINE_THEME_ASSET("asset:623c744e9439"),stock:1,y:2024,vars:{'Diseño':['KTM','ELN9','TLD']},gear:1},
{id:27,n:'STARK VARG EX',cat:'STARK VARG',price:327000,img:window.ELEVENINE_THEME_ASSET("asset:2b71241dc185"),stock:1,y:2025,vars:{Color:['Blanco','Gris','Rojo']}},
{id:28,n:'STARK VARG MX1.2',cat:'STARK VARG',price:307000,img:window.ELEVENINE_THEME_ASSET("asset:a840d957e623"),stock:1,y:2025,vars:{Color:['Gris','Blanco','Rojo']}},
{id:29,n:'STARK VARG SM',cat:'STARK VARG',price:327000,img:window.ELEVENINE_THEME_ASSET("asset:57ccf820bbf2"),stock:1,y:2025,vars:{Color:['Rojo','Blanco','Gris']}},
{id:30,n:'STRIDER Balance Edición Moto',cat:'Bicicletas Infantiles',price:2099,img:'2022/10/balance-edicion-moto',stock:1,y:2022,vars:{'Edición':['BMW','HONDA','KTM','Rockstar','YAMAHA','SHERCO']},age:'balance'},
{id:31,n:'STRIDER Bicicleta de Balance',cat:'Bicicletas Infantiles',price:2099,img:window.ELEVENINE_THEME_ASSET("asset:fb8a3a85731f"),stock:1,y:2022,vars:{Color:['Azul','Negro','Rojo','Rosa']},age:'balance'},
{id:32,n:'SUR-RON LIGHT BEE X',cat:'SUR-RON',price:119900,img:window.ELEVENINE_THEME_ASSET("asset:1c3c9909cba9"),stock:1,y:2026,vars:{Color:['Negro','Verde','Azul','Morado','Blanco']}},
{id:33,n:'SUR-RON ULTRA BEE',cat:'SUR-RON',price:166000,img:'2025/10/ULTRA-2026-NGO',stock:0,y:2026,vars:{Color:['Café','Negro']}},
{id:34,n:'SUR-RON LIGHT BEE 2',cat:'SUR-RON',price:null,img:window.ELEVENINE_THEME_ASSET("asset:0cce66bb2d56"),stock:0,launch:1,y:0,vars:{Color:['Blanco','Negro','Verde','Café']}},
{id:35,n:'Resorte de mejora para amortiguador trasero',cat:'Accesorios SUR-RON',price:null,img:window.ELEVENINE_THEME_ASSET("asset:7e08f8955407"),stock:1,y:2026,quoteOnly:1,vars:{Resistencia:['550 LBS','600 LBS','650 LBS'],Color:['Negro','Rojo','Blanco','Azul','Dorado']}},
{id:36,n:'Estriberas CNC para Ultra Bee',cat:'Accesorios SUR-RON',price:null,img:window.ELEVENINE_THEME_ASSET("asset:67aad9878484"),stock:1,y:2026,quoteOnly:1,vars:{Color:['Negro','Azul','Dorado','Naranja','Rojo','Plata']}},
{id:37,n:'Protector de disco delantero para Ultra Bee',cat:'Accesorios SUR-RON',price:null,img:window.ELEVENINE_THEME_ASSET("asset:67b103c80173"),stock:1,y:2026,quoteOnly:1,vars:{Color:['Negro','Azul','Dorado','Naranja','Rojo','Plata']}},
{id:38,n:'Juego de manijas de freno ajustables para Ultra Bee',cat:'Accesorios SUR-RON',price:null,img:window.ELEVENINE_THEME_ASSET("asset:a79563a8e9a2"),stock:1,y:2026,quoteOnly:1,vars:{Color:['Negro','Azul','Dorado','Naranja','Rojo','Plata']}},
{id:39,n:'Soporte triangular reforzado de amortiguador',cat:'Accesorios SUR-RON',price:null,img:window.ELEVENINE_THEME_ASSET("asset:aa09a0087fc4"),stock:1,y:2026,quoteOnly:1,vars:{Color:['Negro','Azul','Dorado','Verde','Morado','Rojo']}},
{id:40,n:'Bieleta reforzada de suspensión',cat:'Accesorios SUR-RON',price:null,img:window.ELEVENINE_THEME_ASSET("asset:a05ec927f9ba"),stock:1,y:2026,quoteOnly:1,vars:{Color:['Negro','Azul','Dorado','Verde','Naranja','Morado','Rojo','Plata']}},
{id:41,n:'Soporte de cáliper tipo A',cat:'Accesorios SUR-RON',price:null,img:window.ELEVENINE_THEME_ASSET("asset:087d8a9327dc"),stock:1,y:2026,quoteOnly:1,vars:{Color:['Negro','Azul','Dorado','Rojo','Plata']}},
{id:42,n:'Anclaje delantero de horquilla',cat:'Accesorios SUR-RON',price:null,img:window.ELEVENINE_THEME_ASSET("asset:0903b10792c7"),stock:1,y:2026,quoteOnly:1,vars:{Separador:['3 mm','5 mm','15 mm','20 mm'],Color:['Negro','Azul','Dorado','Naranja','Morado','Rojo','Plata']}},
{id:43,n:'Elevador de manubrio',cat:'Accesorios SUR-RON',price:null,img:window.ELEVENINE_THEME_ASSET("asset:b7f5bc576adb"),stock:1,y:2026,quoteOnly:1,vars:{Color:['Negro','Azul','Verde','Naranja','Rojo']}},
{id:44,n:'Disco de freno delantero flotante',cat:'Accesorios SUR-RON',price:null,img:window.ELEVENINE_THEME_ASSET("asset:1c208b9ac858"),stock:1,y:2026,quoteOnly:1},
{id:45,n:'Adaptador de disco delantero o trasero',cat:'Accesorios SUR-RON',price:null,img:window.ELEVENINE_THEME_ASSET("asset:c4bfa8257777"),stock:1,y:2026,quoteOnly:1,vars:{Posición:['Delantero','Trasero']}},
{id:46,n:'Manija de freno abatible para Light Bee / Talaria',cat:'Accesorios SUR-RON',price:null,img:window.ELEVENINE_THEME_ASSET("asset:6ab72d2a5558"),stock:1,y:2026,quoteOnly:1,vars:{Color:['Negro','Azul','Dorado','Naranja','Morado','Rojo','Plata']}},
{id:47,n:'Corona trasera para Light Bee',cat:'Accesorios SUR-RON',price:null,img:window.ELEVENINE_THEME_ASSET("asset:ea6f2aed289e"),stock:1,y:2026,quoteOnly:1,vars:{Dientes:['52T','54T','58T'],Color:['Negro','Azul','Dorado','Verde','Morado','Rojo','Titanio','Naranja']}},
{id:48,n:'Protector inferior para Light Bee',cat:'Accesorios SUR-RON',price:null,img:window.ELEVENINE_THEME_ASSET("asset:cd8b94969bef"),stock:1,y:2026,quoteOnly:1,vars:{Color:['Plata']}},
{id:49,n:'Salpicadera trasera extendida para Light Bee',cat:'Accesorios SUR-RON',price:null,img:window.ELEVENINE_THEME_ASSET("asset:bd7e3701b496"),stock:1,y:2026,quoteOnly:1,vars:{Color:['Negro','Azul','Dorado','Naranja','Morado','Rojo']}},
{id:50,n:'Estriberas CNC para Light Bee',cat:'Accesorios SUR-RON',price:null,img:window.ELEVENINE_THEME_ASSET("asset:7eb0c43e0461"),stock:1,y:2026,quoteOnly:1,vars:{Color:['Negro','Azul','Dorado','Verde','Naranja','Rojo','Plata']}},
{id:51,n:'Protector de disco delantero para Light Bee',cat:'Accesorios SUR-RON',price:null,img:window.ELEVENINE_THEME_ASSET("asset:4356473e97bf"),stock:1,y:2026,quoteOnly:1,vars:{Color:['Negro','Azul','Dorado','Naranja','Morado','Rojo','Plata']}},
{id:52,n:'Pastillas de freno sinterizadas',cat:'Accesorios SUR-RON',price:null,img:window.ELEVENINE_THEME_ASSET("asset:4896f57bc507"),stock:1,y:2026,quoteOnly:1},
{id:53,n:'Elevador de asiento para Light Bee',cat:'Accesorios SUR-RON',price:null,img:window.ELEVENINE_THEME_ASSET("asset:8cca2ed7b382"),stock:1,y:2026,quoteOnly:1,vars:{Color:['Negro','Azul','Dorado','Verde','Morado','Rojo','Plata']}},
{id:54,n:'Pata lateral ajustable',cat:'Accesorios SUR-RON',price:null,img:window.ELEVENINE_THEME_ASSET("asset:a9243e3503f0"),stock:1,y:2026,quoteOnly:1,vars:{Color:['Negro','Azul','Dorado','Rojo','Plata']}}
];
const byId=id=>P.find(p=>p.id===id);
const categoryUrl=name=>name==='SUR-RON'
  ?'/collections/sur-ron#productos'
  :(name==='STARK VARG'
    ?'/collections/stark-varg#productos'
    :(name==='Carpas Profesionales'
      ?'/products/carpas-toldos-personalizados'
      :('/?categoria='+encodeURIComponent(name)+'#productos')));

const CATS=[
 {n:'SUR-RON',c:4,img:'2025/10/ULTRA-2026-NGO',d:'Motos eléctricas off-road'},
 {n:'STARK VARG',c:3,img:'2025/07/STARK-EX',d:'Motocross de competencia'},
 {n:'Bicicletas Infantiles',c:8,img:'2022/10/babybike-2',d:'De 10 meses en adelante'},
 {n:'Cascos Adultos MTB',c:4,img:'2023/12/casco-fullface-adulto',ext:'jpeg',d:'Certificación europea'},
 {n:'Cascos Infantiles',c:1,img:'2022/10/fullface-ngo2-1',d:'Protección para los peques'},
 {n:'Goggles',c:3,img:'2025/02/F1',d:'Visión clara, estilo propio'},
 {n:'Guantes',c:1,img:'2025/02/guante',d:'Agarre y protección'},
 {n:'Sombreros Racing',c:1,img:'2024/06/ELEVENINE-HATS',d:'Estilo de paddock'},
 {n:'Carpas Profesionales',c:1,img:'2024/10/Carpas-1080-x-1080-px',d:'Personalizadas · calidad europea'},
 {n:'Accesorios',c:7,img:'2022/10/bateria',d:'Repuestos y más para ⚡eNINE'}
];

/* ---------- Pack moderno 2026: overrides locales ---------- */
const NEWIMG={21:window.ELEVENINE_THEME_ASSET("embedded:embedded-8da3d6781d65.jpg"),26:window.ELEVENINE_THEME_ASSET("embedded:embedded-9ffd5b58de8c.jpg"),11:window.ELEVENINE_THEME_ASSET("embedded:embedded-a750a344bce1.jpg"),19:window.ELEVENINE_THEME_ASSET("embedded:embedded-4701ea2498b1.jpg"),2:window.ELEVENINE_THEME_ASSET("embedded:embedded-66b1fc2a9b8f.jpg")};
const pimg=p=>/^(?:assets\/|https?:\/\/|\/\/)/.test(String(p.img))?p.img:(NEWIMG[p.id]||img(p.img,p.ext));
const productVideo=p=>window.ELEVENINE_PRODUCT_VIDEOS?.[p.id]||'';
/* ---------- Imagen con fallback thumb ---------- */
const IM=(p)=>productVideo(p)
  ?`<video class="product-loop" data-product-video muted loop playsinline preload="none" aria-label="Video 360 de ${esc(p.n)}"><source src="${productVideo(p)}" type="video/mp4"></video>`
  :(/^(?:assets\/|https?:\/\/|\/\/)/.test(String(p.img))
    ?`<img src="${p.img}" alt="${esc(p.n)}" loading="lazy">`
    :(NEWIMG[p.id]
      ?`<img src="${NEWIMG[p.id]}" alt="${esc(p.n)}" loading="lazy">`
      :`<img src="${img(p.img,p.ext)}" onerror="this.onerror=null;this.src='${thumb(p.img,p.ext)}'" alt="${esc(p.n)}" loading="lazy">`));

/* ---------- Header / menús ---------- */
const hd=document.getElementById('hd'),mega=document.getElementById('mega'),megaBtn=document.getElementById('megaBtn');
window.addEventListener('scroll',()=>{hd.classList.toggle('scrolled',scrollY>10);
  const pr=document.getElementById('promo');if(pr)pr.classList.toggle('hidebar',scrollY>10);},{passive:true});
megaBtn.addEventListener('click',()=>{const o=mega.classList.toggle('open');megaBtn.setAttribute('aria-expanded',o);});
document.addEventListener('click',e=>{if(!mega.contains(e.target)&&e.target!==megaBtn&&!megaBtn.contains(e.target))mega.classList.remove('open');});
const MEGA_VIDEO_PRODUCT={
  'SUR-RON':22,
  'STARK VARG':27,
  'Bicicletas Infantiles':2,
  'Cascos Adultos MTB':15,
  'Cascos Infantiles':14,
  'Goggles':19,
  'Guantes':21,
  'Sombreros Racing':26,
  'Accesorios':5
};
const megaMedia=c=>{
  if(c.n==='Carpas Profesionales'){
    const video=window.ELEVENINE_THEME_ASSET("asset:75afbdef651d");
    return `<video class="product-loop mega-video" data-product-video muted loop playsinline preload="metadata" poster="${window.ELEVENINE_THEME_ASSET("asset:carpas-menu-poster-v7")}" aria-label="Video de ${esc(c.n)}"><source src="${video}" type="video/mp4"></video>`;
  }
  const p=byId(MEGA_VIDEO_PRODUCT[c.n]);
  const video=p&&productVideo(p);
  return video
    ?`<video class="product-loop mega-video" data-product-video muted loop playsinline preload="none" aria-label="Video de ${esc(c.n)}"><source src="${video}" type="video/mp4"></video>`
    :`<img src="${thumb(c.img,c.ext)}" alt="${esc(c.n)}" loading="lazy">`;
};
document.getElementById('megaGrid').innerHTML=CATS.map(c=>`
  <a class="mega-card" href="${categoryUrl(c.n)}" onclick="mega.classList.remove('open')">
    ${megaMedia(c)}
    <div><b>${esc(c.n)}</b><span>${c.c} producto${c.c>1?'s':''} · ${esc(c.d)}</span></div>
  </a>`).join('');
const mnav=document.getElementById('mnav');
document.getElementById('burger').addEventListener('click',()=>mnav.classList.add('open'));
document.getElementById('mnavClose').addEventListener('click',()=>mnav.classList.remove('open'));
mnav.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>mnav.classList.remove('open')));
document.getElementById('searchBtn').addEventListener('click',()=>{
  document.getElementById('botFab').click();
});

/* ---------- Hero: dolly-out + parallax ---------- */
const heroMoto=document.getElementById('heroMoto');
const RM=matchMedia('(prefers-reduced-motion: reduce)').matches;
let mx=0,my=0;
if(!RM){
  addEventListener('scroll',()=>{
    const y=Math.min(scrollY/innerHeight,1);
    if(heroMoto){heroMoto.style.transform=`scale(${1.14-.2*y}) rotate(${-1.5+3*y}deg) translateY(${y*-40}px)`;heroMoto.style.opacity=1-y*.6;}
  },{passive:true});
  addEventListener('mousemove',e=>{
    mx=(e.clientX/innerWidth-.5)*10;my=(e.clientY/innerHeight-.5)*6;
    if(heroMoto&&scrollY<innerHeight*.6)heroMoto.style.translate=`${mx}px ${my}px`;
  },{passive:true});
}

/* ---------- Reveals ---------- */
const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}}),{threshold:.12});
document.querySelectorAll('.rv').forEach(el=>io.observe(el));




/* ---------- Categorías home ---------- */
if(document.getElementById('catGrid')){
document.getElementById('catGrid').innerHTML=CATS.map((c,i)=>`
  <a class="cat-card rv ${i%4===1?'rv-d1':i%4===2?'rv-d2':i%4===3?'rv-d3':''}" href="${categoryUrl(c.n)}">
    <span class="go"><svg viewBox="0 0 24 24"><path d="M7 17L17 7M9 7h8v8"/></svg></span>
    <img src="${img(c.img,c.ext)}" onerror="this.onerror=null;this.src='${thumb(c.img,c.ext)}'" alt="${esc(c.n)}" loading="lazy">
    <b>${esc(c.n)}</b><span>${c.c} producto${c.c>1?'s':''} · ${esc(c.d)}</span>
  </a>`).join('');
document.querySelectorAll('#catGrid .rv').forEach(el=>io.observe(el));
}

/* ---------- Halo destacado ---------- */
const hex2rgb=h=>{const x=h.replace('#','');return [0,2,4].map(i=>parseInt(x.substr(i,2),16)).join(',');};
const destVideos={
  Blanco:window.ELEVENINE_THEME_ASSET("asset:a371fd914084"),
  Gris:window.ELEVENINE_THEME_ASSET("asset:ee909696c3b7"),
  Rojo:window.ELEVENINE_THEME_ASSET("asset:e9c81a131df7")
};
document.querySelectorAll('#destSw .sw').forEach(b=>b.addEventListener('click',()=>{
  document.querySelectorAll('#destSw .sw').forEach(x=>x.classList.remove('on'));b.classList.add('on');
  document.getElementById('destSwLbl').textContent=b.dataset.n;
  document.getElementById('destacado').style.setProperty('--halo',hex2rgb(b.dataset.c));
  const im=document.getElementById('destImg');
  const source=im.querySelector('source');
  const nextVideo=destVideos[b.dataset.n];
  if(nextVideo&&source.getAttribute('src')!==nextVideo){
    source.setAttribute('src',nextVideo);
    im.load();
    if(!RM)im.play().catch(()=>{});
  }
  im.style.transform='scale(1.03) rotate(1deg)';
  setTimeout(()=>im.style.transform='',420);
}));

/* ---------- Tarjeta de línea (SUR-RON / STARK) ---------- */
function lineCard(p){
  const colors=(p.vars&&p.vars.Color)||[];
  return `<article class="line-card rv" data-product-id="${p.id}">
    <span class="stock ${!p.stock?'out':''}">${p.launch?'Nuevo lanzamiento':(p.stock?'En existencia':'Agotado')}</span>
    <div class="imgbox">${IM(p)}</div>
    <span class="cat-lbl">${esc(p.cat)}</span>
    <h3><a href="${window.ELEVENINE_PRODUCT_URL(p.id)}">${esc(p.n)}</a></h3>
    <div class="pr">${priceLabel(p)} ${p.price==null?'':'<small style="font-size:.6em;color:var(--gris-med)">MXN</small>'}</div>
    <div class="swatches" style="margin-bottom:4px">
      ${colors.map((c,i)=>`<button class="sw ${i===0?'on':''}" style="background:${COLORHEX[c]||'#ccc'}" title="${esc(c)}" aria-label="${esc(c)}"
        onclick="lineSw(this,'${hex2rgb(COLORHEX[c]||'#cccccc')}','${esc(c)}')"></button>`).join('')}
    </div>
    <div class="acts">
      <button class="btn btn-dark" onclick="openQV(${p.id})">${p.launch?'Ver lanzamiento':(p.stock?'Configurar':'Consultar')}</button>
      <a class="btn btn-line" target="_blank" rel="noopener" href="https://wa.me/${WA}?text=${encodeURIComponent('Hola ELEVENINE, quiero '+(p.stock?'información y prueba de manejo de la ':'consultar disponibilidad de la ')+p.n)}">WhatsApp</a>
    </div>
  </article>`;
}
window.lineSw=(btn,rgb,color)=>{
  const card=btn.closest('.line-card');
  card.querySelectorAll('.sw').forEach(x=>x.classList.remove('on'));btn.classList.add('on');
  card.style.setProperty('--halo',rgb);
  const media=window.ELEVENINE_PRODUCT_MEDIA?.[Number(card.dataset.productId)]?.variants?.Color;
  const video=card.querySelector('video');
  const source=video?.querySelector('source');
  if(media?.[color]&&source&&source.getAttribute('src')!==media[color]){
    source.setAttribute('src',media[color]);
    video.load();
    if(!RM)video.play().catch(()=>{});
  }
};
if(document.getElementById('surronGrid'))document.getElementById('surronGrid').innerHTML=[22,32,33,34].map(id=>lineCard(byId(id))).join('');
if(document.getElementById('starkGrid'))document.getElementById('starkGrid').innerHTML=[27,28,29].map(id=>lineCard(byId(id))).join('');
document.querySelectorAll('#surronGrid .rv,#starkGrid .rv').forEach(el=>io.observe(el));

/* ---------- Comparador ---------- */
const COMP={surron:[22,32,33],stark:[27,28,29]};
function renderComp(brand){
  const models=COMP[brand].map(byId);
  const prices=models.map(m=>Array.isArray(m.price)?m.price[0]:m.price);
  const min=Math.min(...prices);
  const row=(lbl,fn,best)=>`<tr><td>${lbl}</td>${models.map((m,i)=>`<td class="${best&&best(m,i)?'best':''}">${fn(m,i)}</td>`).join('')}</tr>`;
  document.getElementById('compTable').innerHTML=`
    <thead><tr><th></th>${models.map(m=>`<th><img src="${pimg(m)}" alt="${esc(m.n)}" loading="lazy"><b>${esc(m.n)}</b></th>`).join('')}</tr></thead>
    <tbody>
      ${row('Precio',(m,i)=>priceLabel(m),(m,i)=>brand!=='surron'&&prices[i]===min)}
      ${row('Colores',m=>(m.vars.Color||[]).join(' · '))}
      ${row('Disponibilidad',m=>m.stock?'En existencia':'Agotado',m=>m.stock)}
      ${row('Tren motriz',()=>'100% eléctrico')}
      ${row('Ficha técnica',m=>`<a style="text-decoration:underline" target="_blank" rel="noopener" href="https://wa.me/${WA}?text=${encodeURIComponent('Hola, quiero la ficha técnica completa de la '+m.n)}">Solicitar por WhatsApp</a>`)}
      <tr><td></td>${models.map(m=>`<td><button class="btn btn-dark" style="padding:12px 20px;font-size:12px" onclick="openQV(${m.id})">${m.stock?'Comprar':'Consultar'}</button></td>`).join('')}</tr>
    </tbody>`;
}
if(document.getElementById('compTable'))renderComp('surron');
document.querySelectorAll('.comp-tabs button').forEach(b=>b.addEventListener('click',()=>{
  document.querySelectorAll('.comp-tabs button').forEach(x=>x.classList.remove('on'));b.classList.add('on');
  renderComp(b.dataset.brand);
}));

/* ---------- Tarjeta de producto ---------- */
function pcard(p,compact,best=false){
  const colors=(p.vars&&(p.vars.Color||p.vars['Edición']||p.vars['Versión']||p.vars['Diseño']))||[];
  const shown=colors.slice(0,5);
  return `<article class="pcard${best?' best-card':''}${p.quoteOnly?' quote-card':''}" data-product-id="${p.id}">
    ${best?'<span class="badge best">Más vendido</span>':((p.quoteOnly&&p.price==null)?'<span class="badge">Cotización</span>':(p.launch?'<span class="badge">Nuevo lanzamiento</span>':(p.stock?(p.y>=2025?'<span class="badge">Nuevo</span>':''):'<span class="badge out">Agotado</span>')))}
    <button class="fav" onclick="toggleFav(this)" aria-label="Agregar a favoritos"><svg viewBox="0 0 24 24"><path d="M12 20s-7-4.6-9-9a5 5 0 0 1 9-3 5 5 0 0 1 9 3c-2 4.4-9 9-9 9z"/></svg></button>
    <div class="ph" onclick="openQV(${p.id})">${IM(p)}</div>
    <div class="body">
      <span class="cat-lbl">${esc(p.cat)}</span>
      <h3><a href="${window.ELEVENINE_PRODUCT_URL(p.id)}">${esc(p.n)}</a></h3>
      <div class="pr">${priceLabel(p)}</div>
      ${shown.length?`<div class="mini-sw">${shown.map(c=>`<i style="background:${COLORHEX[c]||'#ccc'}" title="${esc(c)}"></i>`).join('')}${colors.length>5?`<small>+${colors.length-5}</small>`:''}</div>`:''}
      <div class="acts">
        <button class="btn btn-dark" onclick="openQV(${p.id})">${(p.quoteOnly&&p.price==null)?'Ver y cotizar':(p.launch?'Ver lanzamiento':(p.stock?'Ver producto':'Consultar'))}</button>
        ${compact?'':`<button class="btn btn-line" onclick="openQV(${p.id})">Detalles</button>`}
      </div>
    </div>
  </article>`;
}
window.toggleFav=b=>{b.classList.toggle('on');toast(b.classList.contains('on')?'Guardado en favoritos ♥':'Eliminado de favoritos');};

/* ---------- Guía infantil ---------- */
function renderKids(age){
  const list=P.filter(p=>p.age===age);
  document.getElementById('kidsGrid').innerHTML=list.map(p=>pcard(p,true)).join('');
}
if(document.getElementById('kidsGrid'))renderKids('baby');
document.querySelectorAll('#kgSteps button').forEach(b=>b.addEventListener('click',()=>{
  document.querySelectorAll('#kgSteps button').forEach(x=>x.classList.remove('on'));b.classList.add('on');
  renderKids(b.dataset.age);
}));

/* ---------- Lookbook equipamiento ---------- */
if(document.getElementById('gearGrid'))document.getElementById('gearGrid').innerHTML=[15,20,21,26,13,4].map(id=>pcard(byId(id),true)).join('');




/* ---------- Catálogo: estado, filtros, orden, búsqueda ---------- */
const state={cat:'Todo',q:'',sort:'rec',stock:'all'};
if(document.getElementById('prodGrid')){
const CHIP_CATS=['Todo',...CATS.map(c=>c.n)];
function renderChips(){
  ['chips','chipsM'].forEach(id=>{
    document.getElementById(id).innerHTML=CHIP_CATS.map(c=>
      `<button class="chip ${state.cat===c?'on':''}" onclick="setCat('${esc(c)}')">${esc(c)}</button>`).join('');
  });
}
window.setCat=c=>{state.cat=c;renderChips();renderGrid();};
function filtered(){
  let list=P.slice();
  if(state.cat!=='Todo')list=list.filter(p=>p.cat===state.cat);
  if(state.stock==='in')list=list.filter(p=>p.stock);
  if(state.stock==='out')list=list.filter(p=>!p.stock);
  if(state.q){const q=state.q.toLowerCase();list=list.filter(p=>(p.n+' '+p.cat).toLowerCase().includes(q));}
  const val=p=>Array.isArray(p.price)?p.price[0]:p.price;
  if(state.sort==='hi')list.sort((a,b)=>val(b)-val(a));
  if(state.sort==='lo')list.sort((a,b)=>val(a)-val(b));
  if(state.sort==='new')list.sort((a,b)=>b.y-a.y);
  if(state.sort==='stock')list.sort((a,b)=>b.stock-a.stock);
  if(state.sort==='rec')list.sort((a,b)=>(b.stock-a.stock)||(val(b)-val(a)));
  return list;
}
function renderGrid(){
  const list=filtered();
  document.getElementById('resultN').textContent=`Mostrando ${list.length} de ${P.length} productos${state.cat!=='Todo'?' · '+state.cat:''}`;
  document.getElementById('prodGrid').innerHTML=list.length
    ? list.map(p=>pcard(p)).join('')
    : `<div style="grid-column:1/-1;text-align:center;padding:60px 20px;color:var(--gris-med)">
        No encontramos productos con esos filtros.<br><br>
        <button class="btn btn-line" onclick="resetFilters()">Limpiar filtros</button></div>`;
}
window.resetFilters=()=>{state.cat='Todo';state.q='';state.stock='all';document.getElementById('q').value='';document.getElementById('stockSel').value='all';renderChips();renderGrid();};
renderChips();renderGrid();

/* búsqueda predictiva */
const qIn=document.getElementById('q'),sugg=document.getElementById('sugg');
qIn.addEventListener('input',()=>{
  state.q=qIn.value.trim();renderGrid();
  if(state.q.length<2){sugg.classList.remove('open');return;}
  const hits=filtered().slice(0,6);
  sugg.innerHTML=hits.map(p=>`<a href="javascript:void(0)" onclick="openQV(${p.id});sugg.classList.remove('open')">
      <img src="${pimg(p)}" alt="" loading="lazy">
      <div><b>${esc(p.n)}</b><small>${esc(p.cat)} · ${priceLabel(p)} · ${p.launch?'Nuevo lanzamiento':(p.stock?'En existencia':'Agotado')}</small></div></a>`).join('')
    ||'<a><small style="padding:6px">Sin resultados…</small></a>';
  sugg.classList.add('open');
});
document.addEventListener('click',e=>{if(!sugg.contains(e.target)&&e.target!==qIn)sugg.classList.remove('open');});
document.getElementById('sortSel').addEventListener('change',e=>{state.sort=e.target.value;renderGrid();});
document.getElementById('stockSel').addEventListener('change',e=>{state.stock=e.target.value;renderGrid();});
document.getElementById('fBtn').addEventListener('click',()=>openLayer('fPanel'));
document.getElementById('stockOptsM').addEventListener('click',e=>{const b=e.target.closest('.opt');if(!b)return;
  document.querySelectorAll('#stockOptsM .opt').forEach(x=>x.classList.remove('on'));b.classList.add('on');state.stock=b.dataset.v;renderGrid();});
document.getElementById('sortOptsM').addEventListener('click',e=>{const b=e.target.closest('.opt');if(!b)return;
  document.querySelectorAll('#sortOptsM .opt').forEach(x=>x.classList.remove('on'));b.classList.add('on');state.sort=b.dataset.v;renderGrid();});

}
/* ---------- Capas (overlay/qv/cart/panel) ---------- */
const overlay=document.getElementById('overlay');
function openLayer(id){closeAll(true);document.getElementById(id).classList.add('open');overlay.classList.add('open');document.body.style.overflow='hidden';}
window.closeAll=(soft)=>{['qv','cart','fPanel'].forEach(i=>document.getElementById(i).classList.remove('open'));
  if(!soft){overlay.classList.remove('open');document.body.style.overflow='';}};
overlay.addEventListener('click',()=>closeAll());
document.addEventListener('keydown',e=>{if(e.key==='Escape'){closeAll();mega.classList.remove('open');mnav.classList.remove('open');}});

/* ---------- Vista rápida con variantes reales ---------- */
let qvSel={},qvQty=1,qvP=null;
window.openQV=id=>{location.href=window.ELEVENINE_PRODUCT_URL(id);};
function qvComplete(){return !qvP.vars||Object.keys(qvP.vars).every(k=>qvSel[k]);}
function renderQV(){
  const p=qvP;
  const varsHTML=p.vars?Object.entries(p.vars).map(([k,opts])=>`
    <div class="qv-var"><label>${esc(k)} ${qvSel[k]?'· <span style="color:var(--grafito)">'+esc(qvSel[k])+'</span>':'<span style="color:#c33">*requerido</span>'}</label>
      <div class="opt-row">${opts.map(o=>{
        const isColor=COLORHEX[o]&&(k==='Color');
        return isColor
          ?`<button class="sw ${qvSel[k]===o?'on':''}" style="background:${COLORHEX[o]};width:36px;height:36px" title="${esc(o)}" aria-label="${esc(o)}" onclick="qvPick('${esc(k)}','${esc(o)}')"></button>`
          :`<button class="opt ${qvSel[k]===o?'on':''}" onclick="qvPick('${esc(k)}','${esc(o)}')">${esc(o)}</button>`;
      }).join('')}</div>
    </div>`).join(''):'';
  document.getElementById('qvBody').innerHTML=`
    <div class="ph">${IM(p)}</div>
    <span class="cat-lbl" style="font-size:11px;letter-spacing:.16em;text-transform:uppercase;color:var(--gris-med);font-family:var(--font-d);font-weight:600">${esc(p.cat)} · SKU ELN9-${String(p.id).padStart(3,'0')}${p.vars?Object.values(qvSel).map(v=>'-'+v.slice(0,3).toUpperCase()).join(''):''}</span>
    <h3><a href="${window.ELEVENINE_PRODUCT_URL(p.id)}">${esc(p.n)}</a></h3>
    <div class="price-tag" style="font-size:1.5rem">${priceLabel(p)} <small>MXN</small></div>
    <p style="font-size:13.5px;color:var(--gris-med)">${p.stock?'✓ En existencia · Envíos a todo México':'Agotado por el momento · consulta próxima llegada'}</p>
    ${varsHTML}
    <label style="display:block;font-size:11.5px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;font-family:var(--font-d);color:var(--gris-med);margin-top:6px">Cantidad</label>
    <div class="qv-qty">
      <button onclick="qvQ(-1)" aria-label="Menos">−</button><span>${qvQty}</span><button onclick="qvQ(1)" aria-label="Más">+</button>
    </div>
    <div class="qv-acts">
      ${p.stock
        ?`<button class="btn btn-dark" ${qvComplete()?'':'disabled'} onclick="addFromQV()">Agregar al carrito · ${money((Array.isArray(p.price)?p.price[0]:p.price)*qvQty)}</button>
           <button class="btn btn-line" ${qvComplete()?'':'disabled'} onclick="addFromQV(true)">Comprar ahora</button>`
        :`<a class="btn btn-dark" target="_blank" rel="noopener" href="https://wa.me/${WA}?text=${encodeURIComponent('Hola, ¿cuándo llega de nuevo '+p.n+'?')}">Avísame cuando llegue</a>`}
      <a class="btn btn-line" target="_blank" rel="noopener" href="https://wa.me/${WA}?text=${encodeURIComponent('Hola ELEVENINE, tengo dudas sobre: '+p.n)}">Preguntar por WhatsApp</a>
    </div>
    ${p.vars&&!qvComplete()?'<p class="qv-note">Selecciona todas las opciones para habilitar la compra.</p>':''}
    ${Array.isArray(p.price)?'<p class="qv-note">El precio final depende de la opción seleccionada; te lo confirmamos antes de pagar.</p>':''}`;
}
window.qvPick=(k,v)=>{qvSel[k]=v;renderQV();};
window.qvQ=d=>{qvQty=Math.max(1,qvQty+d);renderQV();};

/* ---------- Carrito ---------- */
let cart=[];
try{cart=JSON.parse(localStorage.getItem('eln9cart')||'[]');}catch(e){cart=[];}
function saveCart(){try{localStorage.setItem('eln9cart',JSON.stringify(cart));}catch(e){}}
function cartTotal(){return cart.reduce((s,i)=>s+(Array.isArray(byId(i.id).price)?byId(i.id).price[0]:byId(i.id).price)*i.q,0);}
function cartN(){return cart.reduce((s,i)=>s+i.q,0);}
function updateBadge(){const b=document.getElementById('cartCount');b.textContent=cartN();b.classList.toggle('on',cartN()>0);}
window.addFromQV=(buyNow)=>{
  if(!qvComplete())return;
  const key=qvP.id+'|'+JSON.stringify(qvSel);
  const ex=cart.find(i=>i.key===key);
  ex?ex.q+=qvQty:cart.push({key,id:qvP.id,sel:{...qvSel},q:qvQty});
  saveCart();updateBadge();renderCart();
  toast('Agregado al carrito ✓');
  buyNow?openCart():closeAll();
};
function openCart(){location.href='/cart';}
document.getElementById('cartBtn').addEventListener('click',openCart);
function renderCart(){
  const box=document.getElementById('cartItems'),foot=document.getElementById('cartFoot');
  if(!cart.length){
    box.innerHTML=`<div class="cart-empty">
      <svg viewBox="0 0 24 24"><path d="M6 7h12l-1.2 11a2 2 0 0 1-2 1.8H9.2a2 2 0 0 1-2-1.8L6 7z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg>
      Tu carrito está vacío.<br>Explora el catálogo y encuentra tu próxima máquina.</div>`;
    foot.innerHTML=`<a class="btn btn-line" style="width:100%" href="/#productos">Ver catálogo oficial</a>`;return;
  }
  box.innerHTML=cart.map((i,ix)=>{const p=byId(i.id);const v=Object.entries(i.sel).map(([k,x])=>`${k}: ${x}`).join(' · ');
    return `<div class="ci">
      <img src="${pimg(p)}" alt="${esc(p.n)}">
      <div class="inf"><b>${esc(p.n)}</b>${v?`<small>${esc(v)}</small>`:''}
        <div class="row">
          <div class="q"><button onclick="cq(${ix},-1)" aria-label="Menos">−</button><span>${i.q}</span><button onclick="cq(${ix},1)" aria-label="Más">+</button></div>
          <span class="pr">${money((Array.isArray(p.price)?p.price[0]:p.price)*i.q)}</span>
        </div>
        <button class="rm" onclick="crm(${ix})">Eliminar</button>
      </div></div>`;}).join('');
  const msg='Hola ELEVENINE 👋 Quiero finalizar mi pedido:%0A%0A'+cart.map(i=>{const p=byId(i.id);
    const v=Object.entries(i.sel).map(([k,x])=>`${k} ${x}`).join(', ');
    return `▪ ${i.q}x ${p.n}${v?' ('+v+')':''} — ${money((Array.isArray(p.price)?p.price[0]:p.price)*i.q)}`;
  }).map(encodeURIComponent).join('%0A')+'%0A%0A'+encodeURIComponent('Subtotal: '+money(cartTotal()));
  foot.innerHTML=`
    <div class="tot"><span>Subtotal</span><span>${money(cartTotal())}</span></div>
    <p class="ship">Envío e impuestos se confirman al cerrar el pedido.</p>
    <a class="btn btn-wa" href="https://wa.me/${WA}?text=${msg}" target="_blank" rel="noopener">Finalizar pedido por WhatsApp</a>
    <a class="btn btn-line" style="width:100%" href="/cart">Pagar en línea (tienda oficial)</a>`;
}
window.cq=(ix,d)=>{cart[ix].q=Math.max(1,cart[ix].q+d);saveCart();updateBadge();renderCart();};
window.crm=ix=>{cart.splice(ix,1);saveCart();updateBadge();renderCart();};
updateBadge();

/* ---------- Toast ---------- */
let toastT;
function toast(m){const t=document.getElementById('toast');t.textContent=m;t.classList.add('on');clearTimeout(toastT);toastT=setTimeout(()=>t.classList.remove('on'),2400);}

/* ---------- Formularios → WhatsApp ---------- */
document.querySelectorAll('#carpaOpts .opt').forEach(b=>b.addEventListener('click',()=>{
  document.querySelectorAll('#carpaOpts .opt').forEach(x=>x.classList.remove('on'));b.classList.add('on');
}));
document.querySelectorAll('#carpaExtras .opt').forEach(b=>b.addEventListener('click',()=>b.classList.toggle('on')));
document.getElementById('carpaForm').addEventListener('submit',e=>{
  e.preventDefault();
  const g=id=>document.getElementById(id).value.trim();
  if(!g('cNombre')||!g('cTel')){toast('Completa tu nombre y WhatsApp');return;}
  const medida=document.querySelector('#carpaOpts .opt.on').dataset.v;
  const extras=[...document.querySelectorAll('#carpaExtras .opt.on')].map(b=>b.dataset.v).join(', ')||'Por definir';
  const msg=`Hola ELEVENINE 👋 Quiero cotizar una CARPA PROFESIONAL:%0A%0A▪ Medida: ${medida}%0A▪ Personalizar: ${extras}%0A▪ Nombre: ${g('cNombre')}%0A▪ Empresa/Escudería: ${g('cEquipo')||'—'}%0A▪ Ciudad: ${g('cCiudad')||'—'}%0A▪ Fecha del evento: ${g('cFecha')||'—'}%0A▪ WhatsApp: ${g('cTel')}%0A%0A${g('cMsg')||''}%0A%0AEnvío mis logotipos por este chat.`;
  open(`https://wa.me/${WA}?text=${encodeURIComponent(msg).replace(/%250A/g,'%0A')}`,'_blank');
  toast('Abriendo WhatsApp con tu cotización…');
});
document.getElementById('distForm').addEventListener('submit',e=>{
  e.preventDefault();
  const g=id=>document.getElementById(id).value.trim();
  if(!g('dNombre')||!g('dEmpresa')||!g('dTel')){toast('Completa los campos requeridos');return;}
  const msg=`Hola ELEVENINE 👋 Quiero ser DISTRIBUIDOR:%0A%0A▪ Nombre: ${g('dNombre')}%0A▪ Empresa: ${g('dEmpresa')}%0A▪ Ciudad/Estado: ${g('dCiudad')}%0A▪ WhatsApp: ${g('dTel')}%0A▪ Giro: ${g('dGiro')||'—'}%0A▪ Web/Redes: ${g('dWeb')||'—'}%0A%0A${g('dMsg')||''}`;
  open(`https://wa.me/${WA}?text=${encodeURIComponent(msg).replace(/%250A/g,'%0A')}`,'_blank');
  toast('Abriendo WhatsApp con tu solicitud…');
});
document.getElementById('newsForm').addEventListener('submit',e=>{
  e.preventDefault();
  const em=document.getElementById('nEmail').value.trim();
  if(!em)return;
  open(`mailto:info@elevenine.com.mx?subject=${encodeURIComponent('Suscripción a novedades ELEVENINE')}&body=${encodeURIComponent('Hola, quiero recibir novedades. Mi correo: '+em)}`,'_blank');
  toast('¡Listo! Revisa tu app de correo ✓');
  e.target.reset();
});

document.getElementById('yy').textContent=new Date().getFullYear();

/* ===== V2: parallax bandas + videos eficientes ===== */
(function(){
  const bands=[...document.querySelectorAll('.band .bg')];
  if(!matchMedia('(prefers-reduced-motion: reduce)').matches){
    let tick=false;
    addEventListener('scroll',()=>{
      if(tick)return;tick=true;
      requestAnimationFrame(()=>{
        bands.forEach(bg=>{
          const r=bg.parentElement.getBoundingClientRect();
          if(r.bottom<0||r.top>innerHeight)return;
          const p=(r.top+r.height/2-innerHeight/2)/innerHeight;
          if(bg.tagName==='IMG')bg.style.transform=`scale(1.08) translateY(${p*36}px)`;
        });
        tick=false;
      });
    },{passive:true});
  }
  const vids=[...document.querySelectorAll('video')];
  const vio=new IntersectionObserver(es=>es.forEach(e=>{
    const v=e.target;
    if(e.isIntersecting){v.play().catch(()=>{})}else{v.pause()}
  }),{threshold:.15});
  vids.forEach(v=>vio.observe(v));
})();




/* ============ ASISTENTE NINE · rule-based + catálogo vivo ============ */
(function(){
const fab=document.getElementById('botFab'),panel=document.getElementById('bot'),
      msgs=document.getElementById('botMsgs'),quick=document.getElementById('botQuick'),
      inp=document.getElementById('botInput'),send=document.getElementById('botSend'),
      closeB=document.getElementById('botClose');
const WA='https://wa.me/523327052074';
window.closeBot=function(){document.getElementById('bot').classList.remove('open');document.getElementById('botFab').style.display='flex'};
let opened=false;

const QUICKS=[
  ['🏍️ Motos','motos'],['⚡ Para niños','ninos'],['🪖 Equipo','equipo'],
  ['⛺ Carpas','carpas'],['🚚 Envíos','envios'],['👤 Asesor humano','humano']
];

function el(html){const d=document.createElement('div');d.innerHTML=html;return d.firstElementChild}
function scrollEnd(){msgs.scrollTop=msgs.scrollHeight}
function addUser(t){msgs.appendChild(el(`<div class="bmsg user"></div>`)).textContent=t;scrollEnd()}
function typing(){const t=el('<div class="bot-typing"><i></i><i></i><i></i></div>');msgs.appendChild(t);scrollEnd();return t}
function addBot(html,delay){
  return new Promise(res=>{
    const t=typing();
    setTimeout(()=>{
      t.remove();
      const m=el('<div class="bmsg bot"></div>');
      m.innerHTML=html;
      msgs.appendChild(m);scrollEnd();res(m);
    },delay||Math.min(500+html.length*3,1400));
  });
}
function money(n){return n==null?'PRECIO POR CONFIRMAR':'$'+n.toLocaleString('es-MX',{minimumFractionDigits:2})}
function prodCard(p){
  const pr=Array.isArray(p.price)?money(p.price[0])+' – '+money(p.price[1]):money(p.price);
  const im=NEWIMG[p.id]||img(p.img,p.ext), th=NEWIMG[p.id]||thumb(p.img,p.ext);
  return `<div class="bprod" onclick="openQV(${p.id});closeBot()">
    <img src="${im}" onerror="if(!this.dataset.f){this.dataset.f=1;this.src='${th}'}else{this.style.display='none'}" alt="">
    <div><b>${p.n}</b><small>${pr}${p.stock?'':' · AGOTADO'}</small></div>
    <span class="go">→</span></div>`;
}
function prodList(list,max){
  return list.slice(0,max||3).map(prodCard).join('');
}

/* ---- base de conocimiento ---- */
const KB=[
 {k:/env[ií]o|paqueter|entrega|cu[aá]nto tarda|mandan|llega/i,
  a:'🚚 <b>Sí, enviamos a todo México.</b>\nEl costo y tiempo dependen de tu ciudad y del producto. Al confirmar tu pedido por WhatsApp te damos la cotización exacta de envío al momento.'},
 {k:/garant[ií]a|falla|defecto|devoluci/i,
  a:'✅ <b>Todos nuestros productos cuentan con garantía.</b>\nELEVENINE® es una marca registrada. Escríbenos por WhatsApp con el producto que te interesa y te damos los detalles de cobertura.'},
 {k:/pagar|pago|tarjeta|transferencia|msi|meses|mensualidad|quincena|atrato|cr[eé]dito|efectivo|forma de pago/i,
  a:'💳 Puedes comprar directamente en nuestra <b>tienda en línea</b>. Si deseas <b>crédito</b>, el financiamiento disponible es exclusivamente con <b>ATRATO</b>: solicita tu crédito con tu INE y elige pagos en mensualidades o quincenas. Sujeto a aprobación y condiciones de ATRATO.'},
 {k:/comprar|c[oó]mo (pido|ordeno)|carrito|pedido/i,
  a:'🛒 <b>Así de fácil:</b>\n1. Agrega tus productos al carrito de esta página.\n2. Toca "Finalizar pedido por WhatsApp".\n3. Confirmamos existencias, envío y pago.\n\nO explora el catálogo y pregúntame por cualquier producto.'},
 {k:/distribuidor|mayoreo|revender|negocio/i,
  a:'🤝 <b>¡Buscamos distribuidores!</b>\nLlena el formulario de la sección Distribuidores con los datos de tu negocio y zona, y nuestro equipo te contacta con requisitos y beneficios.\n<a href="#dist" onclick="closeBot()" style="font-weight:700;text-decoration:underline">Ir al formulario →</a>'},
 {k:/carpa|toldo|personaliz|impresi[oó]n|logo/i,
  a:'⛺ <b>Carpas profesionales personalizadas.</b>\nMedidas: 3×3, 3×6 y 4×8 m, en calidad nacional o premium, desde <b>$16,000</b> hasta <b>$47,000 MXN</b>, con impresión de tu marca.\nUsa el configurador de la página para armar tu cotización en 30 segundos.\n<a href="#carpas" onclick="closeBot()" style="font-weight:700;text-decoration:underline">Abrir configurador →</a>'},
 {k:/ficha|especificaci|potencia|autonom[ií]a|bater[ií]a dura|velocidad m[aá]x/i,
  a:'📋 Para darte datos 100% precisos, la <b>ficha técnica completa</b> de cada moto te la enviamos por WhatsApp al momento.\n<a href="'+WA+'?text=Hola,%20quiero%20la%20ficha%20t%C3%A9cnica%20de%20una%20moto" target="_blank" style="font-weight:700;text-decoration:underline">Pedir ficha técnica →</a>'},
 {k:/horario|ubicaci|direcci[oó]n|d[oó]nde est[aá]n|tienda f[ií]sica|showroom|guadalajara|tlajomulco/i,
  a:'📍 <b>Nos ubicamos en:</b>\nMagnolia 197-A, La Tijera, Tlajomulco de Zúñiga, Jalisco.\n📞 33 2705 2074\n✉️ info@elevenine.com.mx'},
 {k:/humano|asesor|persona|agente|whats/i,
  a:'👤 ¡Claro! Te paso directo con el equipo:\n<a href="'+WA+'?text=Hola%20ELEVENINE,%20vengo%20del%20asistente%20de%20la%20web" target="_blank" style="font-weight:700;text-decoration:underline">Abrir WhatsApp →</a>\nResponden el mismo día.'},
];

function findProducts(q){
  q=q.toLowerCase();
  const terms=q.split(/\s+/).filter(w=>w.length>2);
  return P.map(p=>{
    const hay=(p.n+' '+p.cat).toLowerCase();
    let score=0;
    terms.forEach(t=>{if(hay.includes(t))score+=t.length});
    return [score,p];
  }).filter(x=>x[0]>0).sort((a,b)=>b[0]-a[0]).map(x=>x[1]);
}

async function answer(q){
  const ql=q.toLowerCase();
  // intents de categoría directos
  if(/^motos?$|sur-?ron|stark|el[eé]ctrica para adulto|moto grande/i.test(ql)){
    const motos=P.filter(p=>p.cat==='SUR-RON'||p.cat==='STARK VARG');
    await addBot('🏍️ <b>Nuestras motos eléctricas:</b>\n<b>SUR-RON</b> — ligeras y ágiles, desde <b>$83,000</b>.\n<b>STARK VARG</b> — motocross nivel competencia, desde <b>$307,000</b>.'+prodList(motos,6)+'\nToca cualquiera para ver colores y agregarla al carrito.');
    return;
  }
  if(/ni[nñ]o|infantil|beb[eé]|hij[oa]|kids|peque[nñ]|balance|primera bici/i.test(ql)){
    const kids=P.filter(p=>p.cat==='Bicicletas Infantiles');
    await addBot('⚡ <b>Línea infantil por edad:</b>\n👶 <b>10m–2 años:</b> BabyBike\n🚸 <b>2–5 años:</b> STRIDER de balance\n🔋 <b>4–9 años:</b> eléctricas ⚡eNINE 12", 16" y 20"\n🚵 <b>10+ años:</b> MT20 y MTB 29" DEEGAN'+prodList(kids,5)+'\n¿Qué edad tiene? Te recomiendo la ideal.');
    return;
  }
  if(/equipo|casco|goggle|guante|protecci|lente/i.test(ql)){
    const gear=P.filter(p=>/Cascos|Goggles|Guantes|Sombreros/.test(p.cat));
    await addBot('🪖 <b>Equipamiento y protección:</b>'+prodList(gear,6)+'\nToca uno para ver tallas y colores.');
    return;
  }
  // precio de producto específico
  if(/precio|cu[aá]nto (cuesta|vale|sale)/i.test(ql)){
    const found=findProducts(ql.replace(/precio|cu[aá]nto (cuesta|vale|sale)|de|la|el/gi,''));
    if(found.length){await addBot('💰 Esto encontré:'+prodList(found,3));return}
  }
  // knowledge base
  for(const kb of KB){if(kb.k.test(ql)){await addBot(kb.a);return}}
  // búsqueda en catálogo
  const found=findProducts(ql);
  if(found.length){
    await addBot('🔎 Encontré esto en el catálogo:'+prodList(found,4)+'\n¿Era lo que buscabas?');
    return;
  }
  await addBot('🤔 No tengo ese dato exacto, pero el equipo te responde el mismo día:\n<a href="'+WA+'?text='+encodeURIComponent('Hola ELEVENINE: '+q)+'" target="_blank" style="font-weight:700;text-decoration:underline">Preguntar por WhatsApp →</a>\n\nTambién puedo ayudarte con: <b>motos, línea infantil, equipo, carpas, envíos y garantía</b>.');
}

function renderQuicks(){
  quick.innerHTML='';
  QUICKS.forEach(([label,intent])=>{
    const b=document.createElement('button');
    b.textContent=label;
    b.onclick=()=>{addUser(label.replace(/^\S+\s/,''));route(intent)};
    quick.appendChild(b);
  });
}
async function route(intent){
  if(intent==='motos')return answer('motos');
  if(intent==='ninos')return answer('para niños');
  if(intent==='equipo')return answer('equipo');
  if(intent==='carpas')return answer('carpas personalizadas');
  if(intent==='envios')return answer('hacen envíos');
  if(intent==='humano')return answer('asesor humano');
}
async function welcome(){
  await addBot('👋 ¡Hola! Soy el <b>Asistente NINE</b> de ELEVENINE®.\n\nConozco todo el catálogo: motos SUR-RON y STARK VARG, la línea infantil ⚡eNINE, equipamiento y carpas profesionales.\n\n¿Qué estás buscando hoy?',600);
}
function submit(){
  const q=inp.value.trim();
  if(!q)return;
  inp.value='';
  addUser(q);
  answer(q);
}
fab.addEventListener('click',()=>{
  panel.classList.add('open');
  fab.style.display='none';
  if(!opened){opened=true;welcome();renderQuicks()}
  setTimeout(()=>inp.focus(),450);
});
closeB.addEventListener('click',()=>{panel.classList.remove('open');fab.style.display='flex'});
send.addEventListener('click',submit);
inp.addEventListener('keydown',e=>{if(e.key==='Enter')submit()});
})();


/* ===== Sección Productos: más vendidos o categoría seleccionada ===== */
if(document.getElementById('shopGrid')){
  const SHOP=[32,27,19,15];
  const section=document.getElementById('productos');
  const requested=ACTIVE_CATEGORY;
  const categoryExists=requested&&P.some(p=>p.cat===requested);
  const list=categoryExists?P.filter(p=>p.cat===requested):SHOP.map(byId).filter(Boolean);
  const eyebrow=section.querySelector('.eyebrow');
  const line1=section.querySelector('.disp-h .l1');
  const line2=section.querySelector('.disp-h .l2 em');
  const subtitle=section.querySelector('.sec-sub');
  section.classList.toggle('category-catalog',!!categoryExists);
  if(categoryExists){
    eyebrow.textContent='Catálogo ELEVENINE';
    line1.textContent='Explora';
    line2.textContent=requested+'.';
    subtitle.textContent=`${list.length} producto${list.length===1?'':'s'} disponible${list.length===1?'':'s'} en ${requested}. Elige una pieza para ver detalles, variantes y compra.`;
  }
  document.getElementById('shopGrid').innerHTML=list.map(p=>pcard(p,false,!categoryExists)).join('');
  document.querySelectorAll('#shopGrid .rv').forEach(el=>io.observe(el));
}

/* El cursor nativo permanece siempre visible para evitar pérdidas del puntero
   si una animación o un recurso pesado tarda en cargar. */

/* ===== Hero: playlist de 3 videos ===== */
(function(){
  const v=document.getElementById('heroVid');
  if(!v)return;
  const LIST=[window.ELEVENINE_THEME_ASSET("embedded:embedded-794b4ac8726e.mp4"),window.ELEVENINE_THEME_ASSET("embedded:embedded-4d86a6955ec2.mp4"),window.ELEVENINE_THEME_ASSET("embedded:embedded-c73d3c5a86c9.mp4")];
  let i=0;
  function next(){
    i=(i+1)%LIST.length;
    v.style.opacity=0;
    setTimeout(()=>{v.src=LIST[i];v.load();v.play().catch(()=>{});v.style.opacity='';},260);
  }
  v.addEventListener('ended',next);
  v.addEventListener('error',()=>setTimeout(next,400));
  v.addEventListener('canplay',()=>{if(v.paused)v.play().catch(()=>{});});
  v.style.transition='opacity .26s ease';
})();



/* Scroll vertical continuo sobre el hero 3D incrustado. */
(() => {
  'use strict';

  let shell=null;
  let frame=null;
  let releaseTimer=0;
  let animationFrame=0;
  let pendingY=0;

  function resolveHero(){
    shell=document.querySelector('.immersive-hero-embed');
    frame=shell?.querySelector('iframe')||null;
  }

  function releasePointerCapture(){
    if(!shell)return;
    shell.classList.add('is-scroll-pass');
    window.clearTimeout(releaseTimer);
    releaseTimer=window.setTimeout(()=>shell?.classList.remove('is-scroll-pass'),260);
  }

  function flushScroll(){
    animationFrame=0;
    const amount=pendingY;
    pendingY=0;
    if(!amount)return;

    const root=document.documentElement;
    const previousBehavior=root.style.scrollBehavior;
    root.style.scrollBehavior='auto';
    window.scrollBy({top:amount,left:0,behavior:'auto'});
    root.style.scrollBehavior=previousBehavior;
  }

  window.addEventListener('message',event=>{
    if(!frame)resolveHero();
    const data=event.data;
    if(!frame||event.source!==frame.contentWindow||!data||data.type!=='elevenine:hero-scroll')return;

    const verticalDelta=Number(data.y);
    if(!Number.isFinite(verticalDelta)||verticalDelta===0)return;

    releasePointerCapture();
    pendingY+=verticalDelta;
    if(!animationFrame)animationFrame=window.requestAnimationFrame(flushScroll);
  });

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',resolveHero,{once:true});
  else resolveHero();
})();



/* assets/js/product-media.js */
(() => {
  'use strict';

  const selector='video[data-product-video]';
  const reduceMotion=matchMedia('(prefers-reduced-motion: reduce)').matches;
  const observer='IntersectionObserver' in window?new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
      const video=entry.target;
      if(entry.isIntersecting&&!document.hidden&&!reduceMotion){
        video.muted=true;
        video.play().catch(()=>{});
      }else{
        video.pause();
      }
    });
  },{rootMargin:'180px 0px',threshold:.08}):null;

  function enhance(root=document){
    root.querySelectorAll(`${selector}:not([data-video-ready])`).forEach(video=>{
      video.dataset.videoReady='true';
      video.muted=true;
      video.defaultMuted=true;
      if(observer)observer.observe(video);
      else if(!reduceMotion)video.play().catch(()=>{});
    });
  }

  enhance();
  new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(node=>{
    if(node.nodeType!==1)return;
    if(node.matches?.(selector))enhance(node.parentElement||document);
    else enhance(node);
  }))).observe(document.body,{childList:true,subtree:true});

  document.addEventListener('visibilitychange',()=>{
    document.querySelectorAll(selector).forEach(video=>{
      if(document.hidden)video.pause();
      else if(!reduceMotion&&video.getBoundingClientRect().bottom>-180&&video.getBoundingClientRect().top<innerHeight+180)video.play().catch(()=>{});
    });
  });
})();



/* assets/js/v13-index-update.js */
(() => {
  'use strict';

  

  const escape=value=>String(value??'').replace(/[&<>'"]/g,char=>({
    '&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#039;','"':'&quot;'
  }[char]));
  const money=value=>value==null
    ?'PRECIO POR CONFIRMAR'
    :new Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN',minimumFractionDigits:2}).format(Number(value));

  let catalog=[];
  try{
    if(typeof P!=='undefined'&&Array.isArray(P)){
      catalog=P;
      [6,25].forEach(id=>{
        const hiddenIndex=catalog.findIndex(product=>Number(product.id)===id);
        if(hiddenIndex>=0)catalog.splice(hiddenIndex,1);
      });
      const adultHelmet=catalog.find(product=>Number(product.id)===12);
      if(adultHelmet)adultHelmet.vars={...(adultHelmet.vars||{}),Color:['Blanco/Rojo']};
      const fullface=catalog.find(product=>Number(product.id)===15);
      if(fullface)fullface.vars={...(fullface.vars||{}),Color:['Negro','Blanco/Naranja']};
      const lightBee2=catalog.find(product=>Number(product.id)===34);
      if(lightBee2)lightBee2.vars={...(lightBee2.vars||{}),Color:['Blanco','Negro','Verde','Café']};
      const accessoryCompact={
        35:['Resorte de mejora para amortiguador trasero','surron-rear-shock-upgrade-spring','azul.webp',{Resistencia:['550 LBS','600 LBS','650 LBS'],Color:['Negro','Rojo','Blanco','Azul','Dorado']}],
        36:['Estriberas CNC para Ultra Bee','surron-foot-pegs-ultra-bee','azul.webp',{Color:['Negro','Azul','Dorado','Naranja','Rojo','Plata']}],
        37:['Protector de disco delantero para Ultra Bee','surron-front-disc-guard-ultra-bee','azul.webp',{Color:['Negro','Azul','Dorado','Naranja','Rojo','Plata']}],
        38:['Juego de manijas de freno ajustables para Ultra Bee','surron-adjustable-brake-lever-set-ultra-bee','azul.webp',{Color:['Negro','Azul','Dorado','Naranja','Rojo','Plata']}],
        39:['Soporte triangular reforzado de amortiguador','surron-reinforced-shock-triangle-bracket','azul.webp',{Color:['Negro','Azul','Dorado','Verde','Morado','Rojo']}],
        40:['Bieleta reforzada de suspensión','surron-shock-linkage-bracket','azul.webp',{Color:['Negro','Azul','Dorado','Verde','Naranja','Morado','Rojo','Plata']}],
        41:['Soporte de cáliper tipo A','surron-caliper-bracket-a-type','azul.webp',{Color:['Negro','Azul','Dorado','Rojo','Plata']}],
        42:['Anclaje delantero de horquilla','surron-front-fork-anchor','azul.webp',{Separador:['3 mm','5 mm','15 mm','20 mm'],Color:['Negro','Azul','Dorado','Naranja','Morado','Rojo','Plata']}],
        43:['Elevador de manubrio','surron-handlebar-riser','azul.webp',{Color:['Negro','Azul','Verde','Naranja','Rojo']}],
        44:['Disco de freno delantero flotante','surron-front-floating-brake-rotor','principal.webp',null],
        45:['Adaptador de disco delantero o trasero','surron-rotor-adapter-set-front-rear','delantero.webp',{Posición:['Delantero','Trasero']}],
        46:['Manija de freno abatible para Light Bee / Talaria','surron-folding-brake-lever-light-bee-talaria','azul.webp',{Color:['Negro','Azul','Dorado','Naranja','Morado','Rojo','Plata']}],
        47:['Corona trasera para Light Bee','surron-rear-sprocket-light-bee','52t-azul.webp',{Dientes:['52T','54T','58T'],Color:['Negro','Azul','Dorado','Verde','Morado','Rojo','Titanio','Naranja']}],
        48:['Protector inferior para Light Bee','surron-skid-plate-light-bee','plata.webp',{Color:['Plata']}],
        49:['Salpicadera trasera extendida para Light Bee','surron-extended-rear-fender-light-bee','azul.webp',{Color:['Negro','Azul','Dorado','Naranja','Morado','Rojo']}],
        50:['Estriberas CNC para Light Bee','surron-foot-pegs-light-bee','azul.webp',{Color:['Negro','Azul','Dorado','Verde','Naranja','Rojo','Plata']}],
        51:['Protector de disco delantero para Light Bee','surron-front-disc-guard-light-bee','azul.webp',{Color:['Negro','Azul','Dorado','Naranja','Morado','Rojo','Plata']}],
        52:['Pastillas de freno sinterizadas','surron-brake-pads','principal.webp',null],
        53:['Elevador de asiento para Light Bee','surron-seat-riser','azul.webp',{Color:['Negro','Azul','Dorado','Verde','Morado','Rojo','Plata']}],
        54:['Pata lateral ajustable','surron-adjustable-kickstand','azul.webp',{Color:['Negro','Azul','Dorado','Rojo','Plata']}]
      };
      Object.entries(accessoryCompact).forEach(([id,[name,slug,file,variants]])=>{
        const product=catalog.find(item=>Number(item.id)===Number(id));
        if(!product)return;
        product.n=name;
        product.img=window.ELEVENINE_THEME_ASSET(`assets/products/surron-accessories/catalog-v2/${slug}/${file}`);
        product.vars=variants||undefined;
      });
      if(typeof CATS!=='undefined'&&Array.isArray(CATS)){
        const mtbCategoryIndex=CATS.findIndex(category=>category.n==='Bicicletas MTB 29″');
        if(mtbCategoryIndex>=0)CATS.splice(mtbCategoryIndex,1);
        const bikes=CATS.find(category=>category.n==='Bicicletas Infantiles');
        if(bikes)bikes.c=7;
      }
    }
  }catch(error){
    console.warn('No fue posible ajustar el catálogo compacto.',error);
  }
  if(ACTIVE_CATEGORY==='Accesorios SUR-RON'&&typeof renderShop==='function'){
    renderShop();
  }

  document.querySelectorAll('[data-product-id="6"],[data-product-id="25"]').forEach(card=>card.remove());
  document.querySelectorAll('.cat-card,.mega-card').forEach(card=>{
    if(card.textContent.includes('Bicicletas MTB 29'))card.remove();
  });
  document.querySelectorAll('[data-product-id="12"] .sw[title="Negro/Verde"]').forEach(swatch=>swatch.remove());
  document.querySelectorAll('.cat-card').forEach(card=>{
    if(card.querySelector('b')?.textContent.trim()!=='Bicicletas Infantiles')return;
    const meta=card.querySelector('b + span');
    if(meta)meta.textContent=meta.textContent.replace(/^\d+\s+productos?/, '7 productos');
  });

  const productById=id=>catalog.find(product=>Number(product.id)===Number(id));
  const imageFor=product=>{
    if(typeof pimg==='function')return pimg(product);
    if(/^(?:assets\/|https?:\/\/|\/\/)/.test(String(product.img||'')))return product.img;
    return `https://elevenine.com.mx/wp-content/uploads/${product.img}.${product.ext||'jpg'}`;
  };
  const priceFor=product=>{
    if(product.price==null)return'PRECIO POR CONFIRMAR';
    if(Array.isArray(product.price))return`${money(product.price[0])} – ${money(product.price[1])}`;
    return money(product.price);
  };
  const videoFor=(product,colors=[],year='')=>{
    const media=window.ELEVENINE_PRODUCT_MEDIA?.[Number(product.id)];
    if(!media)return'';
    if(year&&media.modelDefaults?.[year])return media.modelDefaults[year];
    const variant=media.modelVariants?.[year]?.Color||media.variants?.Color||{};
    return colors.map(color=>variant[color]).find(Boolean)||media.default||'';
  };
  const modelDefaultColors={
    '22-2025':'Rosa',
    '22-2026':'Azul',
    '34-':'Blanco'
  };
  const colorHex={
    Blanco:'#f5f5f2',
    Negro:'#171717',
    Verde:'#76aa3b',
    Azul:'#2f69c9',
    Morado:'#6d3da1',
    Amarillo:'#f1cf00',
    Rosa:'#ed6fa9',
    'Café':'#76523f'
  };
  const modelCard=(id,year,colors,options={})=>{
    const product=productById(id);
    if(!product)return'';
    const url=window.ELEVENINE_PRODUCT_URL(product.id)+(year?'?modelo='+encodeURIComponent(year):'');
    const media=window.ELEVENINE_PRODUCT_MEDIA?.[Number(product.id)];
    const variantVideos=media?.modelVariants?.[year]?.Color||media?.variants?.Color||{};
    const defaultColor=modelDefaultColors[`${product.id}-${year}`]||colors[0];
    const video=videoFor(product,[defaultColor,...colors.filter(color=>color!==defaultColor)],year);
    const generationLabel=options.eyebrow||(year?`SUR-RON · MODELO ${year}`:'SUR-RON · NUEVO LANZAMIENTO');
    const accessibleSuffix=year?` modelo ${year}`:' nuevo lanzamiento';
    const promo=window.ELEVENINE_SURRON_PROMOS?.[`${product.id}:${year}`]||null;
    const promoMarkup=promo?`
      <div class="surron-promo" aria-label="${escape(promo.label)}">
        <span class="surron-promo-label">${escape(promo.label)}</span>
        <div class="surron-promo-before">Antes <del>${escape(money(promo.previousPrice))}</del></div>
        <div class="surron-promo-bonus">Bono de <strong>${escape(money(promo.bonus))}</strong></div>
        ${Array.isArray(promo.conditions)&&promo.conditions.length?`<small>${promo.conditions.map(escape).join(' · ')}</small>`:''}
      </div>`:'';
    return `<article class="surron-model-card${promo?' has-promo':''}" data-product-id="${product.id}" data-modelo="${year||'nuevo-lanzamiento'}">
      <div class="surron-model-media">
        ${video
          ?`<video data-product-video muted loop playsinline preload="none" aria-label="${escape(product.n)}${accessibleSuffix}"><source src="${escape(video)}" type="video/mp4"></video>`
          :`<img src="${escape(imageFor(product))}" alt="${escape(product.n)}${accessibleSuffix}" loading="lazy">`}
      </div>
      <div class="surron-model-body">
        <small>${escape(generationLabel)}</small>
        <h4><a href="${url}">${escape(product.n)}</a></h4>
        ${promo?'<span class="surron-promo-now">AHORA</span>':''}
        <div class="surron-model-price">${escape(priceFor(product))}</div>
        ${promoMarkup}
        <div class="surron-color-list" aria-label="Colores disponibles">${colors.map(color=>`
          <button
            type="button"
            class="surron-color-swatch ${color===defaultColor?'active':''}"
            style="--swatch:${colorHex[color]||'#ddd'}"
            data-model-video="${escape(variantVideos[color]||'')}"
            aria-label="Ver ${escape(product.n)}${accessibleSuffix} en color ${escape(color)}"
            aria-pressed="${color===defaultColor?'true':'false'}"
            title="${escape(color)}"
          ></button>`).join('')}</div>
        <div class="surron-model-actions">
          <a href="${url}">Ver producto</a>
        </div>
      </div>
    </article>`;
  };
  const yearsMarkup=()=>`
    <div class="surron-year-block" data-year="2025">
      <div class="surron-year-heading">
        <div><small>LÍNEA SUR-RON</small><h3>2025</h3></div>
        <p>Dos configuraciones listas para elegir en sus colores exclusivos de la línea 2025.</p>
      </div>
      <div class="surron-year-grid">
        ${modelCard(22,'2025',['Amarillo','Verde','Azul','Rosa'])}
        ${modelCard(32,'2025',['Negro','Verde','Azul','Morado'])}
      </div>
    </div>
    <div class="surron-year-block" data-year="2026">
      <div class="surron-year-heading">
        <div><small>LÍNEA SUR-RON</small><h3>2026</h3></div>
        <p>La gama más reciente de SUR-RON, con potencia actualizada y nuevas configuraciones.</p>
      </div>
      <div class="surron-year-grid">
        ${modelCard(22,'2026',['Azul','Verde','Amarillo'])}
        ${modelCard(32,'2026',['Blanco','Negro','Verde','Morado'])}
        ${modelCard(33,'2026',['Café','Negro'])}
      </div>
    </div>
    <div class="surron-year-block surron-launch-block" data-year="nuevo-lanzamiento">
      <div class="surron-year-heading">
        <div><small>PLUS · LÍNEA INDEPENDIENTE</small><h3>NUEVO LANZAMIENTO</h3></div>
        <p>Light Bee 2 se presenta como una línea adicional e independiente, disponible en Negro, Verde, Blanco y Café.</p>
      </div>
      <div class="surron-year-grid">
        ${modelCard(34,'',['Negro','Verde','Blanco','Café'],{eyebrow:'SUR-RON · NUEVO LANZAMIENTO'})}
      </div>
    </div>`;

  document.addEventListener('click',event=>{
    const swatch=event.target.closest('.surron-model-card [data-model-video]');
    if(!swatch)return;
    const card=swatch.closest('.surron-model-card');
    const src=swatch.dataset.modelVideo;
    const video=card?.querySelector('.surron-model-media video');
    if(!src||!video)return;
    const source=video.querySelector('source');
    if(source?.getAttribute('src')!==src){
      source?.setAttribute('src',src);
      video.load();
      video.play().catch(()=>{});
    }
    card.querySelectorAll('[data-model-video]').forEach(button=>{
      const active=button===swatch;
      button.classList.toggle('active',active);
      button.setAttribute('aria-pressed',String(active));
    });
  });

  const hero=document.getElementById('hero');
  const socialAnchor=document.getElementById('destacado')||document.getElementById('productos')||hero;
  const isCatalogView=Boolean(ACTIVE_CATEGORY);
  if(socialAnchor&&!isCatalogView&&!document.querySelector('.social-invite')){
    socialAnchor.insertAdjacentHTML('afterend',`
      <section class="social-invite" id="redes" aria-labelledby="social-title">
        <div class="social-invite-inner">
          <small>SÍGUENOS · @ELEVEN9.MX</small>
          <h2 id="social-title">SI TE GUSTA LO QUE VES, <em>¡IMAGÍNATELO EN VIVO!</em></h2>
          <p>Descubre nuevas máquinas, configuraciones, lanzamientos y lo que pasa detrás de cada rodada. Síguenos en redes como <strong>@eleven9.mx</strong>.</p>
          <div class="social-links">
            <a href="https://www.instagram.com/eleven9.mx/" target="_blank" rel="noopener" aria-label="Seguir a ELEVENINE en Instagram">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zm0 2a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H7zm11 1.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5zM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"/></svg>
              Instagram
            </a>
            <a href="https://www.facebook.com/eleven9.mx" target="_blank" rel="noopener" aria-label="Seguir a ELEVENINE en Facebook">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14 8h3V4h-3c-3 0-5 2-5 5v2H6v4h3v7h4v-7h3l1-4h-4V9c0-.7.3-1 1-1z"/></svg>
              Facebook
            </a>
            <a href="https://www.tiktok.com/@eleven9.mx?lang=es" target="_blank" rel="noopener" aria-label="Seguir a ELEVENINE en TikTok">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 3c.5 2.4 1.9 3.8 4 4v3c-1.6 0-3-.5-4-1.3V15a6 6 0 1 1-5-5.9v3.2A3 3 0 1 0 12 15V3h3z"/></svg>
              TikTok
            </a>
          </div>
        </div>
      </section>`);
  }

  const featured=document.getElementById('destacado');
  if(featured&&!document.querySelector('.surron-lines')){
    featured.insertAdjacentHTML('afterend',`
      <section class="surron-lines" id="surron-modelos" aria-labelledby="surron-lines-title">
        <div class="surron-lines-head">
          <div>
            <img src="${escape(window.ELEVENINE_THEME_ASSET("asset:a4f687e30942"))}" alt="SUR-RON">
            <h2 id="surron-lines-title">ELIGE TU LÍNEA.</h2>
          </div>
          <p>Encuentra la SUR-RON ideal para tu nivel, estilo de manejo y próxima aventura.</p>
        </div>
        ${yearsMarkup()}
      </section>`);
  }

  const requested=ACTIVE_CATEGORY;
  if(requested==='Bicicletas MTB 29″'){
    location.replace('/#productos');
    return;
  }
  const shopGrid=document.getElementById('shopGrid');
  const categoryBrand=requested==='SUR-RON'||requested==='Accesorios SUR-RON'
    ?{src:window.ELEVENINE_THEME_ASSET("asset:a4f687e30942"),alt:'SUR-RON'}
    :(requested==='STARK VARG'?{src:window.ELEVENINE_THEME_ASSET("asset:cc731637469b"),alt:'STARK FUTURE'}:null);
  if(categoryBrand){
    const productsWrap=document.querySelector('#productos .wrap');
    const heading=productsWrap?.querySelector('h2.disp-h, h2');
    if(heading&&!productsWrap.querySelector('.catalog-brand-logo')){
      heading.insertAdjacentHTML('beforebegin',`
        <div class="catalog-brand-logo" aria-label="Marca ${escape(categoryBrand.alt)}">
          <img src="${escape(categoryBrand.src)}" alt="${escape(categoryBrand.alt)}">
        </div>`);
    }
  }
  if(requested==='Accesorios SUR-RON'){
    const productsWrap=document.querySelector('#productos .wrap');
    const subtitle=productsWrap?.querySelector('.sec-sub');
    if(subtitle)subtitle.textContent='20 accesorios de rendimiento y protección para SUR-RON. Consulta compatibilidad, disponibilidad y precio con nuestro equipo.';
    if(productsWrap&&!productsWrap.querySelector('.catalog-brochure-intro')){
      const anchor=productsWrap.querySelector('.sec-sub')||productsWrap.querySelector('h2');
      anchor?.insertAdjacentHTML('afterend',`
        <div class="catalog-brochure-intro">
          <span>CATÁLOGO MOPAIKE · ACCESORIOS SUR-RON</span>
          <a href="${escape(window.ELEVENINE_THEME_ASSET("asset:c5e2dfd0351f"))}" target="_blank" rel="noopener">VER BROCHURE COMPLETO <b aria-hidden="true">↗</b></a>
        </div>`);
    }
  }
  if(shopGrid&&requested==='SUR-RON'){
    shopGrid.classList.remove('prod-grid');
    shopGrid.classList.add('surron-category-years');
    shopGrid.innerHTML=yearsMarkup();
    const subtitle=document.querySelector('#productos .sec-sub');
    if(subtitle)subtitle.textContent='Elige tu modelo SUR-RON por generación y encuentra la configuración ideal para tu próxima rodada.';
  }else if(shopGrid){
    shopGrid.querySelectorAll('[data-product-id="6"],[data-product-id="25"]').forEach(card=>card.remove());
    if(requested==='Bicicletas Infantiles'){
      const subtitle=document.querySelector('#productos .sec-sub');
      if(subtitle)subtitle.textContent='7 productos de línea disponibles: eNINE 12″, 16″ y 20″, Baby Bike y bicicletas de balance.';
    }
  }

  const contact=document.getElementById('contacto');
  if(contact&&!document.querySelector('.showroom-invite')){
    contact.insertAdjacentHTML('beforebegin',`
      <section class="showroom-invite" id="showroom" aria-labelledby="showroom-title">
        <div class="showroom-invite-inner">
          <div>
            <small>VIVE ELEVENINE EN PERSONA</small>
            <h2 id="showroom-title">CONÓCELO. PRUÉBALO. SIÉNTELO.</h2>
            <p>Visita nuestras instalaciones y showroom para conocer físicamente nuestros productos o realizar una prueba de manejo. La atención es con cita previa para preparar cada detalle y hacer que tu experiencia con nosotros sea única y real.</p>
          </div>
          <aside>
            <strong>Visita con cita previa</strong>
            <span>Agenda por WhatsApp el día y horario de tu visita o prueba de manejo.</span>
            <a class="showroom-button" target="_blank" rel="noopener" href="https://wa.me/523327052074?text=${encodeURIComponent('Hola ELEVENINE, quiero agendar una visita al showroom y conocer o probar sus productos.')}">AGENDAR EXPERIENCIA →</a>
          </aside>
        </div>
      </section>`);
  }

  const removePosters=root=>{
    root.querySelectorAll?.('video[data-product-video][poster]').forEach(video=>video.removeAttribute('poster'));
  };
  removePosters(document);
  new MutationObserver(mutations=>mutations.forEach(mutation=>mutation.addedNodes.forEach(node=>{
    if(node.nodeType!==1)return;
    if(node.matches?.('video[data-product-video][poster]'))node.removeAttribute('poster');
    removePosters(node);
  }))).observe(document.body,{childList:true,subtree:true});

  /* En las URLs de colección aterriza en la misma vista de catálogo que usaba el filtro anterior. */
  if(window.ELEVENINE_COLLECTION_CATEGORY){
    const focusCollection=()=>{
      const products=document.getElementById('productos');
      if(!products)return;
      const offset=innerWidth<=720?82:104;
      scrollTo({top:Math.max(0,products.getBoundingClientRect().top+scrollY-offset),behavior:'auto'});
    };
    requestAnimationFrame(()=>requestAnimationFrame(focusCollection));
    addEventListener('load',focusCollection,{once:true});
  }
})();



/* Integración nativa de Shopify sin alterar la interfaz. */
(() => {
  'use strict';
  const handles = window.ELEVENINE_PRODUCT_HANDLES;
  const nativeCatalog = window.ELEVENINE_NATIVE_CATALOG || {};
  const nativeRoute = href => {
    if (!href) return href;
    const value = String(href);
    const idMatch = value.match(/(?:^|\/)producto\.html\?id=([^&#]+)(.*)$/i);
    if (idMatch) {
      const id = decodeURIComponent(idMatch[1]);
      const handle = handles[id];
      if (!handle) return '/';
      const extra = idMatch[2] || '';
      return '/products/' + encodeURIComponent(handle) + (extra ? '?' + extra.replace(/^&/, '') : '');
    }
    const slugMatch = value.match(/(?:^|\/)producto\.html\?slug=([^&#]+)(.*)$/i);
    if (slugMatch) return '/products/' + slugMatch[1] + (slugMatch[2] ? '?' + slugMatch[2].replace(/^&/, '') : '');
    if (/(?:^|\/)(?:productos|tienda)\/?(?:[?#]|$)/i.test(value)) return '/#productos';
    if (/(?:^|\/)carrito\/?(?:[?#]|$)/i.test(value)) return '/cart';
    if (/carrito\.html/i.test(value)) return '/cart';
    if (/checkout\.html/i.test(value)) return '/checkout';
    if (/index\.html/i.test(value)) return value.replace(/(?:^|\/)index\.html/i, '/');
    return value;
  };
  window.ELEVENINE_NATIVE_ROUTE = nativeRoute;
  window.openQV = id => {
    const handle = handles[String(id)];
    location.href = handle ? '/products/' + encodeURIComponent(handle) : '/';
  };

  try {
    if (typeof P !== 'undefined' && Array.isArray(P)) {
      P.forEach(item => {
        const handle = handles[String(item.id)];
        const current = nativeCatalog[handle];
        if (!current) return;
        if (!item.quoteOnly && !item.launch) item.stock = Boolean(current.available);
        if (!item.quoteOnly && Number.isFinite(Number(current.priceMin))) {
          item.price = current.priceMin === current.priceMax
            ? current.priceMin / 100
            : [current.priceMin / 100, current.priceMax / 100];
        }
      });
      if (typeof renderGrid === 'function') renderGrid();
      if (document.getElementById('surronGrid') && typeof lineCard === 'function') {
        document.getElementById('surronGrid').innerHTML=[22,32,33,34].map(id=>lineCard(byId(id))).join('');
        document.querySelectorAll('#surronGrid .rv').forEach(el=>io.observe(el));
      }
      if (document.getElementById('compTable') && typeof renderComp === 'function') {
        const activeBrand=document.querySelector('.comp-tabs button.on')?.dataset.brand||'surron';
        renderComp(activeBrand);
      }
    }
  } catch (error) {
    console.warn('No fue posible sincronizar la vista del catálogo.', error);
  }

  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const anchor = event.target.closest('a[href]');
    if (!anchor || anchor.target === '_blank') return;
    const href = anchor.getAttribute('href');
    if (!href || !/(?:producto|carrito|checkout|index)\.html/i.test(href)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    location.href = nativeRoute(href);
  }, true);

  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(response => response.ok ? response.json() : Promise.reject())
    .then(cart => {
      document.querySelectorAll('[data-cart-count],#cartCount').forEach(node => {
        node.textContent = cart.item_count || 0;
        node.classList.toggle('on', cart.item_count > 0);
        node.classList.toggle('is-visible', cart.item_count > 0);
      });
    })
    .catch(() => {});
})();
